<template>
  <div class="moduleSetting">
    <div class="tabs">
      <button class="tab toCapitalize"
        v-for="(button, index) in settingTab"
        :key="index"
        :data-setting_type="button.type"
        :class="{ active: button.type === settingType, f_medium: button.type === settingType }"
        @click="onTabClick">
        {{ button.label }}
      </button>
    </div>
    <div v-if="isActive" class="list">
      <!-- layout setting options -->
      <div v-if="settingType === 'layout'" class="listBox">
        <!-- 기본공통:: 위치 고정 -->
        <div class="item">
          <div class="checkbox">
            <input type="checkbox" id="active_sticky" v-model="settingData.layout.sticky">
            <label for="active_sticky" class="label toCapitalize f_medium">{{ locale.module_fix_position }}</label>
          </div>
        </div>
        <!-- // 기본공통:: 위치 고정 -->
        <!-- 기본공통:: 최대폭 -->
        <div class="item">
          <div class="mb5">
            <div class="checkbox">
              <input type="checkbox" id="active_max_width" v-model="settingData.layout.activeMaxWidth">
              <label for="active_max_width" class="label toCapitalize f_medium">{{locale.max_width}}</label>
            </div>
          </div>
          <div v-if="settingData.layout.activeMaxWidth" class="optionGroup">
            <div>
              <!-- <div :class="{radioItem: true, active: !settingData.layout.maxWidth || settingData.layout.maxWidth === '0'}" data-item="5">
                <input type="radio" name="setting_maxwidth" id="setting_maxwidth_0" value="0" v-model="settingData.layout.maxWidth">
                <label for="setting_maxwidth_0">{{locale.none}}</label>
              </div> -->
              <div :class="{radioItem: true, active: settingData.layout.maxWidth === '80'}" data-item="5">
                <input type="radio" name="setting_maxwidth" id="setting_maxwidth_80" value="80" v-model="settingData.layout.maxWidth">
                <label for="setting_maxwidth_80">4/5</label>
              </div>
              <div :class="{radioItem: true, active: settingData.layout.maxWidth === '75'}" data-item="5">
                <input type="radio" name="setting_maxwidth" id="setting_maxwidth_75" value="75" v-model="settingData.layout.maxWidth">
                <label for="setting_maxwidth_75">3/4</label>
              </div>
              <div :class="{radioItem: true, active: settingData.layout.maxWidth === '50'}" data-item="5">
                <input type="radio" name="setting_maxwidth" id="setting_maxwidth_50" value="50" v-model="settingData.layout.maxWidth">
                <label for="setting_maxwidth_50">1/2</label>
              </div>
              <div :class="{radioItem: true, active: settingData.layout.maxWidth === '40'}" data-item="5">
                <input type="radio" name="setting_maxwidth" id="setting_maxwidth_40" value="40" v-model="settingData.layout.maxWidth">
                <label for="setting_maxwidth_40">2/5</label>
              </div>
              <div :class="{radioItem: true, active: settingData.layout.maxWidth === '33'}" data-item="5">
                <input type="radio" name="setting_maxwidth" id="setting_maxwidth_33" value="33" v-model="settingData.layout.maxWidth">
                <label for="setting_maxwidth_33">1/3</label>
              </div>
              <div :class="{radioItem: true, break: true, mt5: true, borderAll: true, active: settingData.layout.maxWidth === 'input'}" data-item="clear">
                <input type="radio" name="setting_maxwidth" id="setting_maxwidth_input" value="input" v-model="settingData.layout.maxWidth">
                <label for="setting_maxwidth_input">{{locale.direct_input}}</label>
              </div>
              <div class="radioItem borderAll mt5 ml5" :class="{disabled: settingData.layout.maxWidth !== 'input'}">
                <input type="input" class="input" v-model="settingData.layout.maxWidthInput"><i class="unit">px</i>
              </div>
            </div>
          </div>
        </div>
        <!-- //기본공통:: 최대폭 -->
        <!-- 기본공통:: 번역방지 -->
        <div class="item">
          <div class="checkbox">
            <input type="checkbox" id="no_translate" v-model="settingData.layout.noTranslate">
            <label for="no_translate" class="label toCapitalize f_medium">{{locale.no_translate}}</label>
          </div>
        </div>
        <!-- //기본공통:: 번역방지 -->
        <div v-for="opt in layoutList" :key="opt.name" class="item">
          <!-- active 체크하는 옵션들 -->
          <div v-if="typeof (opt.active) !== 'undefined'">
            <!-- 기본공통:: 사용여부 -->
            <div class="checkbox">
              <input type="checkbox" :id="`active_${opt.name}`" v-model="settingData.layout[opt.name].active">
              <label :for="`active_${opt.name}`" class="label toCapitalize f_medium">{{locale[opt.name]}}</label>
            </div>
            <!-- //기본공통:: 사용여부 -->
            <!-- 기본:: fullsize -->
            <div v-if="settingData.layout[opt.name].active && opt.name === 'fullsize'">
              <p class="sysMessage">{{locale.message_fullsize}}</p>
              <div class="optionGroup">
                <div class="label toCapitalize colorGrey">{{locale.align}}</div>
                <div class="box setAlignItems">
                  <div :class="{radioItem: true, active: settingData.layout.fullsize.alignItems === 'top'}">
                    <input type="radio" name="setting_align_fullsize" id="setting_align_fullsize_flex-start" value="top" v-model="settingData.layout.fullsize.alignItems">
                    <label for="setting_align_fullsize_flex-start">start</label>
                  </div>
                  <div :class="{radioItem: true, active: settingData.layout.fullsize.alignItems === 'center'}">
                    <input type="radio" name="setting_align_fullsize" id="setting_align_fullsize_center" value="center" v-model="settingData.layout.fullsize.alignItems">
                    <label for="setting_align_fullsize_center">center</label>
                  </div>
                  <div :class="{radioItem: true, active: settingData.layout.fullsize.alignItems === 'bottom'}">
                    <input type="radio" name="setting_align_fullsize" id="setting_align_fullsize_flex-end" value="bottom" v-model="settingData.layout.fullsize.alignItems">
                    <label for="setting_align_fullsize_flex-end">end</label>
                  </div>
                </div>
              </div>
            </div>
            <!-- //기본:: fullsize -->
            <!-- 기본:: link -->
            <div v-if="settingData.layout[opt.name].active && opt.name === 'link'">
              <SetLink :link="settingData.layout.link" />
            </div>
            <!-- //기본:: link -->
            <!-- 기본:: background -->
            <div v-if="settingData.layout[opt.name].active && opt.name === 'background'">
              <div class="optionGroup">
                <div class="label toCapitalize colorGrey">{{locale.color}}</div>
                <div class="box">
                  <div class="colorPreset" :class="{ active: openedColorPicker === 'background' }">
                    <div class="btnColorPicker"
                      @click.stop="toggleColorPicker('background', settingData.layout.background.color)">
                      {{settingData.layout.background.color}}
                      <i :style="{backgroundColor: settingData.layout.background.color}"></i>
                    </div>
                    <sketch-picker v-if="openedColorPicker === 'background'"
                      :value="currentColor.color"
                      class="vc-sketch"
                      @input="onChangeColor"
                      @click.stop />
                  </div>
                  <div v-if="settingData.layout.background.value !== ''">
                    <span class="checkbox small">
                      <input type="checkbox" id="colorOverlay" v-model="settingData.layout.background.overlay">
                      <label for="colorOverlay">{{locale.overlay_color}}</label>
                  </span>
                  </div>
                </div>
              </div>
              <div class="optionGroup">
                <div class="label toCapitalize colorGrey">{{locale.image}}</div>
                <div class="box">
                  <div v-if="settingData.layout.background.value === ''">
                    <input type="file" id="setting_uploadimage" @change="uploadImage(settingData.layout.background, $event)">
                    <label for="setting_uploadimage" class="btn btnFull btnWhite">upload</label>
                  </div>
                  <div v-else>
                    <div class="bgThumb">
                      <img :src="settingData.layout.background.value" alt="" />
                      <button type="button" class="delThumb" @click="deleteImage(settingData.layout.background)"><img src="~@/assets/img/ico_close.svg" alt=""></button>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 배경이미지 옵션 -->
              <div v-if="settingData.layout.background.value !== ''">
                <div class="optionGroup">
                  <div class="label toCapitalize colorGrey">{{locale.editor_setting_repeat}}</div>
                  <div class="box" data-item="4">
                    <div :class="{radioItem: true, active: settingData.layout.background.repeat === 'no-repeat'}">
                      <input type="radio" name="background_repeat" id="background_repeat_n" value="no-repeat" v-model="settingData.layout.background.repeat">
                      <label for="background_repeat_n">{{locale.none}}</label>
                    </div>
                    <div :class="{radioItem: true, active: settingData.layout.background.repeat === 'repeat-x'}">
                      <input type="radio" name="background_repeat" id="background_repeat_x" value="repeat-x" v-model="settingData.layout.background.repeat">
                      <label for="background_repeat_x">{{locale.editor_setting_repeat_x}}</label>
                    </div>
                    <div :class="{radioItem: true, active: settingData.layout.background.repeat === 'repeat-y'}">
                      <input type="radio" name="background_repeat" id="background_repeat_y" value="repeat-y" v-model="settingData.layout.background.repeat">
                      <label for="background_repeat_y">{{locale.editor_setting_repeat_y}}</label>
                    </div>
                    <div :class="{radioItem: true, active: settingData.layout.background.repeat === 'repeat'}">
                      <input type="radio" name="background_repeat" id="background_repeat_xy" value="repeat" v-model="settingData.layout.background.repeat">
                      <label for="background_repeat_xy">{{locale.editor_setting_repeat_xy}}</label>
                    </div>
                  </div>
                </div>
                <div class="optionGroup">
                  <div class="label toCapitalize colorGrey">{{locale.editor_setting_size}}</div>
                  <div class="box">
                    <div :class="{radioItem: true, active: settingData.layout.background.size === 'auto'}">
                      <input type="radio" name="background_size" id="background_size_auto" value="auto" v-model="settingData.layout.background.size">
                      <label for="background_size_auto">{{locale.editor_setting_size_original}}</label>
                    </div>
                    <div :class="{radioItem: true, active: settingData.layout.background.size === 'cover'}">
                      <input type="radio" name="background_size" id="background_size_cover" value="cover" v-model="settingData.layout.background.size">
                      <label for="background_size_cover">{{locale.editor_setting_size_cover}}</label>
                    </div>
                    <div :class="{radioItem: true, active: settingData.layout.background.size === 'contain'}">
                      <input type="radio" name="background_size" id="background_size_contain" value="contain" v-model="settingData.layout.background.size">
                      <label for="background_size_contain">{{locale.editor_setting_size_contain}}</label>
                    </div>
                  </div>
                </div>
                <div class="optionGroup">
                  <div class="label toCapitalize colorGrey">{{locale.editor_setting_position}}</div>
                  <div class="box spot9">
                    <div :class="{radioItem: true, active: settingData.layout.background.position === '0 0'}">
                      <input type="radio" name="background_pos" id="background_pos_0" value="0 0" v-model="settingData.layout.background.position">
                      <label for="background_pos_0"></label>
                    </div>
                    <div :class="{radioItem: true, active: settingData.layout.background.position === '50% 0'}">
                      <input type="radio" name="background_pos" id="background_pos_1" value="50% 0" v-model="settingData.layout.background.position">
                      <label for="background_pos_1"></label>
                    </div>
                    <div :class="{radioItem: true, active: settingData.layout.background.position === '100% 0'}">
                      <input type="radio" name="background_pos" id="background_pos_2" value="100% 0" v-model="settingData.layout.background.position">
                      <label for="background_pos_2"></label>
                    </div>
                    <div :class="{radioItem: true, active: settingData.layout.background.position === '0 50%'}">
                      <input type="radio" name="background_pos" id="background_pos_3" value="0 50%" v-model="settingData.layout.background.position">
                      <label for="background_pos_3"></label>
                    </div>
                    <div :class="{radioItem: true, active: settingData.layout.background.position === '50% 50%'}">
                      <input type="radio" name="background_pos" id="background_pos_4" value="50% 50%" v-model="settingData.layout.background.position">
                      <label for="background_pos_4"></label>
                    </div>
                    <div :class="{radioItem: true, active: settingData.layout.background.position === '100% 50%'}">
                      <input type="radio" name="background_pos" id="background_pos_5" value="100% 50%" v-model="settingData.layout.background.position">
                      <label for="background_pos_5"></label>
                    </div>
                    <div :class="{radioItem: true, active: settingData.layout.background.position === '0 100%'}">
                      <input type="radio" name="background_pos" id="background_pos_6" value="0 100%" v-model="settingData.layout.background.position">
                      <label for="background_pos_6"></label>
                    </div>
                    <div :class="{radioItem: true, active: settingData.layout.background.position === '50% 100%'}">
                      <input type="radio" name="background_pos" id="background_pos_7" value="50% 100%" v-model="settingData.layout.background.position">
                      <label for="background_pos_7"></label>
                    </div>
                    <div :class="{radioItem: true, active: settingData.layout.background.position === '100% 100%'}">
                      <input type="radio" name="background_pos" id="background_pos_8" value="100% 100%" v-model="settingData.layout.background.position">
                      <label for="background_pos_8"></label>
                    </div>
                  </div>
                </div>
              </div>
              <!-- //배경이미지 옵션 -->
            </div>
            <!-- //기본:: background -->
            <!-- 기본:: border -->
            <div v-if="settingData.layout[opt.name].active && opt.name === 'border'">
              <div class="optionGroup">
                <div class="label toCapitalize colorGrey">{{locale.color}}</div>
                <div class="box">
                  <div class="colorPreset" :class="{ active: openedColorPicker === 'border' }">
                    <div class="btnColorPicker"
                      @click.stop="toggleColorPicker('border', settingData.layout.border.color)">
                      {{settingData.layout.border.color}}
                      <i :style="{backgroundColor: settingData.layout.border.color}"></i>
                    </div>
                    <sketch-picker v-if="openedColorPicker === 'border'"
                      :value="currentColor.color"
                      class="vc-sketch"
                      @input="onChangeColor"
                      @click.stop />
                  </div>
                </div>
              </div>
              <div class="optionGroup">
                <div class="label toCapitalize colorGrey">{{locale.style}}</div>
                <div class="box">
                  <div :class="{radioItem: true, active: settingData.layout.border.style === 'solid'}">
                    <input type="radio" name="setting_border_style" id="setting_border_solid" value="solid" v-model="settingData.layout.border.style">
                    <label for="setting_border_solid">{{locale.editor_setting_solid}}</label>
                  </div>
                  <div :class="{radioItem: true, active: settingData.layout.border.style === 'dotted'}">
                    <input type="radio" name="setting_border_style" id="setting_border_dotted" value="dotted" v-model="settingData.layout.border.style">
                    <label for="setting_border_dotted">{{locale.editor_setting_dotted}}</label>
                  </div>
                  <div :class="{radioItem: true, active: settingData.layout.border.style === 'dashed'}">
                    <input type="radio" name="setting_border_style" id="setting_border_dashed" value="dashed" v-model="settingData.layout.border.style">
                    <label for="setting_border_dashed">{{locale.editor_setting_dashed}}</label>
                  </div>
                </div>
              </div>
            </div>
            <!-- //기본:: border -->
            <!-- 기본:: text color -->
            <div v-if="settingData.layout[opt.name].active && opt.name === 'text'">
              <div class="optionGroup">
                <div class="label toCapitalize colorGrey">{{locale.color}}</div>
                <div class="box">
                  <div class="colorPreset" :class="{ active: openedColorPicker === 'text' }">
                    <div class="btnColorPicker"
                      @click.stop="toggleColorPicker('text', settingData.layout.text.color)">
                      {{settingData.layout.text.color}}
                      <i :style="{backgroundColor: settingData.layout.text.color}"></i>
                    </div>
                    <sketch-picker v-if="openedColorPicker === 'text'"
                      :value="currentColor.color"
                      class="vc-sketch"
                      @input="onChangeColor"
                      @click.stop />
                  </div>
                </div>
              </div>
            </div>
            <!-- //기본:: text color -->
            <!-- 기본:: padding -->
            <div v-if="settingData.layout[opt.name].active && opt.name === 'padding'">
              <div class="optionGroup">
                <div class="label toCapitalize colorGrey">{{locale.editor_setting_updown}}</div>
                <div class="box">
                  <div :class="{radioItem: true, active: settingData.layout.padding.tb === '0'}">
                    <input type="radio" name="setting_padding_tb" id="setting_padding_tb0" value="0" v-model="settingData.layout.padding.tb">
                    <label for="setting_padding_tb0">{{locale.none}}</label>
                  </div>
                  <div :class="{radioItem: true, active: settingData.layout.padding.tb === '15'}">
                    <input type="radio" name="setting_padding_tb" id="setting_padding_tb15" value="15" v-model="settingData.layout.padding.tb">
                    <label for="setting_padding_tb15">{{locale.default}}</label>
                  </div>
                  <div :class="{radioItem: true, active: settingData.layout.padding.tb === '30'}">
                    <input type="radio" name="setting_padding_tb" id="setting_padding_tb30" value="30" v-model="settingData.layout.padding.tb">
                    <label for="setting_padding_tb30">{{locale.editor_setting_wide}}</label>
                  </div>
                </div>
              </div>
              <div class="optionGroup">
                <div class="label toCapitalize colorGrey">{{locale.editor_setting_leftright}}</div>
                <div class="box">
                  <div :class="{radioItem: true, active: settingData.layout.padding.lr === '0'}">
                    <input type="radio" name="setting_padding_lr" id="setting_padding_lr0" value="0" v-model="settingData.layout.padding.lr">
                    <label for="setting_padding_lr0">{{locale.none}}</label>
                  </div>
                  <div :class="{radioItem: true, active: settingData.layout.padding.lr === '15'}">
                    <input type="radio" name="setting_padding_lr" id="setting_padding_lr15" value="15" v-model="settingData.layout.padding.lr">
                    <label for="setting_padding_lr15">{{locale.default}}</label>
                  </div>
                  <div :class="{radioItem: true, active: settingData.layout.padding.lr === '30'}">
                    <input type="radio" name="setting_padding_lr" id="setting_padding_lr30" value="30" v-model="settingData.layout.padding.lr">
                    <label for="setting_padding_lr30">{{locale.editor_setting_wide}}</label>
                  </div>
                </div>
              </div>
            </div>
            <!-- //기본:: padding -->
          </div>
          <!-- //active 체크하는 옵션들 -->
          <!-- 기본:: flex -->
          <div v-if="opt.name === 'flex'">
            <div class="label toCapitalize f_medium">{{locale.column}}</div>
            <div class="optionGroup">
              <div class="label toCapitalize colorGrey">{{locale.ratio}}</div>
              <div class="box">
                <div class="setFlex">
                  <div v-for="(column, index) in columnData.column" :key="`${mId}_${index}`" class="flexInner" :style="{flex: column.flex}">
                    <input type="text" class="input" @input="setNumber(column, 'flex')" v-model="column.flex" />
                  </div>
                </div>
              </div>
            </div>
            <div class="optionGroup">
              <div class="label toCapitalize colorGrey">{{locale.align}}</div>
              <div class="box setAlignItems">
                <div :class="{radioItem: true, active: settingData.layout.flex.alignItems === 'flex-start'}">
                  <input type="radio" name="setting_align_flex" id="setting_align_flex-start" value="flex-start" v-model="settingData.layout.flex.alignItems">
                  <label for="setting_align_flex-start">start</label>
                </div>
                <div :class="{radioItem: true, active: settingData.layout.flex.alignItems === 'center'}">
                  <input type="radio" name="setting_align_flex" id="setting_align_flex-center" value="center" v-model="settingData.layout.flex.alignItems">
                  <label for="setting_align_flex-center">center</label>
                </div>
                <div :class="{radioItem: true, active: settingData.layout.flex.alignItems === 'flex-end'}">
                  <input type="radio" name="setting_align_flex" id="setting_align_flex-end" value="flex-end" v-model="settingData.layout.flex.alignItems">
                  <label for="setting_align_flex-end">end</label>
                </div>
              </div>
            </div>
          </div>
          <!-- //기본:: flex -->
          <!-- 기본:: flexible columns -->
          <div v-if="opt.name === 'columns'">
            <div class="label toCapitalize f_medium">{{locale.column}}</div>
            <div class="optionGroup">
              <div class="label toCapitalize colorGrey">{{locale.column_height}}</div>
              <div class="box">
                <div class="checkbox">
                  <input type="checkbox" id="column_stretch" v-model="settingData.layout.columns.stretch">
                  <label for="column_stretch" class="label toCapitalize f_medium">{{locale.align_height}}</label>
                </div>
              </div>
            </div>
            <div class="optionGroup">
              <div class="label toCapitalize colorGrey">{{locale.module_column_min_width}}</div>
              <div class="box">
                <div class="radioItem">
                  <input type="input" class="input" v-model="settingData.layout.columns.minWidth"><i class="unit">px</i>
                </div>
              </div>
            </div>
            <div class="optionGroup">
              <div class="label toCapitalize colorGrey">{{locale.ratio}}</div>
              <div class="box">
                <div v-if="columnData.column.length" class="setFlex">
                  <div
                    v-for="(column, index) in columnData.column"
                    :key="`${mId}_${index}`"
                    class="flexInner"
                    :style="{flex: column.flex}"
                    :class="{break: column.type === 'break'}">
                    <input v-if="column.type !== 'break'" type="text" class="input" @input="setNumber(column, 'flex')" v-model="column.flex" />
                  </div>
                </div>
                <p v-else class="mt10">{{locale.message_add_column}}</p>
              </div>
            </div>
            <div class="optionGroup">
              <div class="label toCapitalize colorGrey">{{locale.align}}</div>
              <div class="box setAlignItems">
                <div :class="{radioItem: true, active: settingData.layout.columns.alignItems === 'flex-start'}">
                  <input type="radio" name="setting_align_flex" id="setting_align_flex-start" value="flex-start" v-model="settingData.layout.columns.alignItems">
                  <label for="setting_align_flex-start">start</label>
                </div>
                <div :class="{radioItem: true, active: settingData.layout.columns.alignItems === 'center'}">
                  <input type="radio" name="setting_align_flex" id="setting_align_flex-center" value="center" v-model="settingData.layout.columns.alignItems">
                  <label for="setting_align_flex-center">center</label>
                </div>
                <div :class="{radioItem: true, active: settingData.layout.columns.alignItems === 'flex-end'}">
                  <input type="radio" name="setting_align_flex" id="setting_align_flex-end" value="flex-end" v-model="settingData.layout.columns.alignItems">
                  <label for="setting_align_flex-end">end</label>
                </div>
              </div>
            </div>
            <div class="optionGroup">
              <div class="label toCapitalize colorGrey">{{locale.spacing}}</div>
              <div class="box">
                <div :class="{radioItem: true, active: settingData.layout.columns.padding.lr === '0'}">
                  <input type="radio" name="setting_column_padding_lr" id="setting_column_padding_lr0" value="0" v-model="settingData.layout.columns.padding.lr">
                  <label for="setting_column_padding_lr0">{{locale.none}}</label>
                </div>
                <div :class="{radioItem: true, active: settingData.layout.columns.padding.lr === '8'}">
                  <input type="radio" name="setting_column_padding_lr" id="setting_padding_column_lr8" value="8" v-model="settingData.layout.columns.padding.lr">
                  <label for="setting_padding_column_lr8">{{locale.default}}</label>
                </div>
                <div :class="{radioItem: true, active: settingData.layout.columns.padding.lr === '15'}">
                  <input type="radio" name="setting_column_padding_lr" id="setting_column_padding_lr15" value="15" v-model="settingData.layout.columns.padding.lr">
                  <label for="setting_column_padding_lr15">{{locale.editor_setting_wide}}</label>
                </div>
              </div>
            </div>
          </div>
          <!-- //기본:: flexible columns -->
        </div>
      </div>
      <!-- //layout setting options -->
      <!-- action setting options -->
      <div v-else-if="settingType === 'action'" class="listBox">
        <div v-if="settingData.action === null" class="requireMessage">{{locale.editor_not_support}}</div>
        <div v-else>
          <!-- 기능 공통:: 필수체크 -->
          <div v-if="settingAction.isRequired" class="item">
            <div class="checkbox">
              <input type="checkbox" id="required" v-model="settingData.action.isRequired" :disabled="settingAction.essential" />
              <label for="required" class="toCapitalize f_medium">{{locale.required}}</label>
            </div>
          </div>
          <!-- //기능 공통:: 필수체크 -->
          <!-- 기능 공통:: 시스템id(서버에서 별도로 처리하는 용도) -->
          <div v-if="settingAction.isRequired && name !== 'cert'" class="item">
            <div class="optionGroup">
              <div class="label colorGrey">ID</div>
              <div class="box">
                <select class="input input2" v-model="settingData.action.dataVariable">
                  <option value="">{{locale.none}}</option>
                  <option v-for="variable in dataVariable"
                    :key="variable"
                    :value="variable"
                    :disabled="variableActive.includes(variable)">
                    {{variable}}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <!-- 기능 공통:: 시스템id(서버에서 별도로 처리하는 용도) -->
          <!-- 기능:: input -->
          <div v-if="name === 'input'">
            <div class="item">
              <div class="optionGroup">
                <div class="label toCapitalize colorGrey">{{locale.label}}</div>
                <div class="box">
                  <!-- 게스트뷰 label -->
                  <input type="text" class="input" v-model="settingData.action.label[activeLang]" @focusout="updateLabel(settingData.action, $event)" />
                  <!-- 어드민 label -->
                  <input type="text" class="input input2" v-model="settingData.action.labelValue" />
                  <div class="mt10">
                    {{locale.font_size}}
                    <select class="input select" v-model="settingData.action.labelFontSize">
                      <option
                        v-for="(size, index) in fontSize"
                        :key="index"
                        :value="`${size}`">
                        {{ size }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div class="item">
              <div class="optionGroup">
                <div class="label toCapitalize colorGrey">{{locale.input_field}}</div>
                <div class="box">
                  <div>{{locale.font_size}}</div>
                  <select class="input select" v-model="settingData.action.valueFontSize">
                    <option
                      v-for="(size, index) in fontSize"
                      :key="index"
                      :value="`${size}`">
                      {{ size }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="item">
              <div class="checkbox">
                <!-- 입력값 센터에서 번역보기 -->
                <input type="checkbox" id="check_input_translate" v-model="settingData.action.translate">
                <label for="check_input_translate">{{locale.support_translate}}</label>
              </div>
            </div>
          </div>
          <!--//기능:: input -->
          <!-- 기능:: textarea -->
          <div v-if="name === 'textarea'">
            <div class="item">
              <div class="optionGroup">
                <div class="label toCapitalize colorGrey">{{locale.label}}</div>
                <div class="box itemList">
                  <!-- 게스트뷰 label -->
                  <input type="text" class="input" v-model="settingData.action.label[activeLang]" @focusout="updateLabel(settingData.action, $event)" />
                  <!-- 어드민 label -->
                  <input type="text" class="input input2" v-model="settingData.action.labelValue" />
                  <div class="mt10">
                    {{locale.font_size}}
                    <select class="input select" v-model="settingData.action.labelFontSize">
                      <option
                        v-for="(size, index) in fontSize"
                        :key="index"
                        :value="`${size}`">
                        {{ size }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div class="item">
              <div class="optionGroup">
                <div class="label toCapitalize colorGrey">{{locale.input_field}}</div>
                <div class="box">
                  <div>{{locale.font_size}}</div>
                  <select class="input select" v-model="settingData.action.valueFontSize">
                    <option
                      v-for="(size, index) in fontSize"
                      :key="index"
                      :value="`${size}`">
                      {{ size }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="item">
              <div class="checkbox">
                <!-- 입력값 센터에서 번역보기 -->
                <input type="checkbox" id="check_textarea_translate" v-model="settingData.action.translate">
                <label for="check_textarea_translate">{{locale.support_translate}}</label>
              </div>
            </div>
          </div>
          <!--//기능:: textarea -->
          <!-- 기능:: radio -->
          <div v-if="name === 'radio'">
            <div class="item">
              <div class="optionGroup">
                <div class="label toCapitalize colorGrey">{{locale.label}}</div>
                <div class="box">
                  <!-- 게스트뷰 label -->
                  <input type="text" class="input" v-model="settingData.action.label[activeLang]" @focusout="updateLabel(settingData.action, $event)" />
                  <!-- 어드민 label -->
                  <input type="text" class="input input2" v-model="settingData.action.labelValue" />
                  <div class="mt10">
                    {{locale.font_size}}
                    <select class="input select" v-model="settingData.action.labelFontSize">
                      <option
                        v-for="(size, index) in fontSize"
                        :key="index"
                        :value="`${size}`">
                        {{ size }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <!-- 옵션 수량 -->
            <div class="item">
              <div class="checkbox toCapitalize f_medium">
                <input type="checkbox" id="optionQuantity" v-model="settingData.action.optionQuantity" @change="setOptionQuantity(settingData.action.optionQuantity)" />
                <label for="optionQuantity">{{locale.editor_setting_option_minmax}}</label>
              </div>
              <div v-if="settingData.action.optionQuantity" class="optionGroup">
                <div class="label toCapitalize colorGrey">{{`${locale.min}~${locale.max}`}}</div>
                <div class="box">
                  <div class="unit hasColumn">
                    <div class="unitColumn">
                      <input type="text"
                         v-model="settingData.action.min"
                         class="input"
                         data-quantity="min"
                         @input="setQuantity(settingData.action, 'min')"
                         @focusout="validateQuantity(settingData.action)" />
                    </div>
                    <div class="unitColumn">
                      <input type="text"
                        v-model="settingData.action.max"
                        class="input"
                        data-quantity="max"
                        @input="setQuantity(settingData.action, 'max')"
                        @focusout="validateQuantity(settingData.action)" />
                    </div>
                    <p class="message">{{ validateQuantity(settingData.action) }}</p>
                  </div>
                </div>
              </div>
            </div>
            <!-- //옵션 수량 -->
            <!-- 옵션  -->
            <div class="item">
              <div class="label toCapitalize f_medium">{{locale.option}}</div>
              <div class="label checkbox toCapitalize f_medium">
                <input type="checkbox" id="hasDefault" v-model="settingData.action.hasDefault" @change="setHasDefault(settingData.action.hasDefault)" />
                <label for="hasDefault">{{locale.set_default}}</label>
                <div class="mt5"><p class="sysMessage">{{locale.message_set_default_option}}</p></div>
              </div>
              <div class="mb15">
                {{locale.font_size}}
                <select class="input select" v-model="settingData.action.valueFontSize">
                  <option
                    v-for="(size, index) in fontSize"
                    :key="index"
                    :value="`${size}`">
                    {{ size }}
                  </option>
                </select>
              </div>
              <div>
                <ul class="itemList">
                  <li v-for="(item, index) in settingData.action.item" :key="`radio_${index}`" class="listItem">
                    <!-- 게스트뷰 항목 label / 다국어 -->
                    <input type="text" class="input" v-model="item.label[activeLang]" @focusout="updateLabel(item, $event)" />
                    <!-- 어드민 항목 label -->
                    <input type="text" class="input input2" v-model="item.value">
                    <!-- 금액 -->
                    <div class="setOptionPrice">
                      <span class="toCapitalize colorGrey">{{locale.price}}</span>
                      <input type="text" class="input input2" v-model="item.price">
                      <button v-if="supportPlu" type="button" class="btnPlu" @click="setPlu(item, index)">PLU</button>
                    </div>
                    <!-- 추가옵션 -->
                    <div class="setSubOption setOptionPrice">
                      <span class="toCapitalize colorGrey">{{locale.page_option_suboption}}</span>
                      <select class="input input2" v-model="item.subOption">
                        <option value="">{{locale.none}}</option>
                        <option v-for="o in optionMods"
                          :key="o.id"
                          :value="o.id"
                          :disabled="o.disabled">
                          {{o.setting.action.labelValue}}
                        </option>
                      </select>
                    </div>
                    <!-- 식별코드 -->
                    <div class="setOptionPrice">
                      <span class="checkbox toCapitalize colorGrey">
                        <input type="checkbox" :id="`option_${index}_pId`" v-model="item.pIdActive">
                        <label :for="`option_${index}_pId`">{{locale.product_id}}</label>
                      </span>
                      <input v-if="item.pIdActive" type="text" class="input input2" v-model="item.pId">
                    </div>
                    <!-- 식별코드타입 -->
                    <div v-if="item.pIdActive" class="setSubOption setOptionPrice">
                      <span class="toCapitalize colorGrey">{{locale.pidtype}}</span>
                      <select class="input input2" v-model="item.pIdTypeId" @change="setPidType(item)">
                        <option v-for="pid in pIdType"
                          :key="pid.id"
                          :value="pid.id">
                          {{pid.id === '#none' ? locale.none : pid.label}}
                        </option>
                      </select>
                    </div>
                    <!-- 옵션 삭제 -->
                    <button type="button" class="btnRemove" @click="removeOption(settingData.action.item, index, settingData.action)">{{locale.delete}}</button>
                  </li>
                </ul>
                <button type="button" class="btn btnFull btnWhite toCapitalize" @click="addOption(settingData.action)">{{locale.editor_action_addoption}}</button>
              </div>
            </div>
            <!-- //옵션  -->
          </div>
          <!--//기능:: radio -->
          <!-- 기능:: checkbox -->
          <div v-if="name === 'checkbox'">
            <div class="item">
              <div class="optionGroup">
                <div class="label toCapitalize colorGrey">{{locale.label}}</div>
                <div class="box">
                  <!-- 게스트뷰 label -->
                  <input type="text" class="input" v-model="settingData.action.label[activeLang]" @focusout="updateLabel(settingData.action, $event)" />
                  <!-- 어드민 label -->
                  <input type="text" class="input input2" v-model="settingData.action.labelValue" />
                  <div class="mt10">
                    {{locale.font_size}}
                    <select class="input select" v-model="settingData.action.labelFontSize">
                      <option
                        v-for="(size, index) in fontSize"
                        :key="index"
                        :value="`${size}`">
                        {{ size }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <!-- 옵션 수량 -->
            <div class="item">
              <div class="checkbox toCapitalize f_medium">
                <input type="checkbox" id="optionQuantity" v-model="settingData.action.optionQuantity" @change="setOptionQuantity(settingData.action.optionQuantity)" />
                <label for="optionQuantity">{{locale.editor_setting_option_minmax}}</label>
              </div>
              <div v-if="settingData.action.optionQuantity" class="optionGroup">
                <div class="label toCapitalize colorGrey">{{`${locale.min}~${locale.max}`}}</div>
                <div class="box">
                  <div class="unit hasColumn">
                    <div class="unitColumn">
                      <input type="text"
                        v-model="settingData.action.min"
                        class="input" data-quantity="min"
                        @input="setQuantity(settingData.action, 'min')"
                        @focusout="validateQuantity(settingData.action)" />
                    </div>
                    <div class="unitColumn">
                      <input type="text"
                        v-model="settingData.action.max"
                        class="input"
                        data-quantity="max"
                        @input="setQuantity(settingData.action, 'max')"
                        @focusout="validateQuantity(settingData.action)" />
                    </div>
                    <p class="message">{{ validateQuantity(settingData.action) }}</p>
                  </div>
                </div>
              </div>
            </div>
            <!-- //옵션 수량 -->
            <!-- 옵션 선택 조건 -->
            <div class="item">
              <div class="checkbox toCapitalize f_medium">
                <input type="checkbox" id="optionCondition" v-model="settingData.action.optionCondition" />
                <label for="optionCondition">{{locale.editor_setting_option_confition}}</label>
              </div>
              <div v-if="settingData.action.optionCondition" class="optionCondition">
                <div class="optionGroup">
                  <div class="label toCapitalize colorGrey">{{locale.min}}</div>
                  <div class="box">
                    <span class="checkbox onoff">
                      <input type="checkbox"
                        id="checkbox_condition_gt"
                        v-model="settingData.action.conditionGt"
                        @click="checkOptionCondition('gt', $event)">
                      <label for="checkbox_condition_gt"></label>
                    </span>
                    <div v-if="settingData.action.conditionGt">
                      <input
                        type="text"
                        class="input"
                        v-model="settingData.action.conditionGtVal"
                        @input="optionConditionVal('gt', $event)"
                        @focus="validateOptionCondition('gt', settingData.action.conditionGt)"> {{locale.option_condition_gt}}
                    </div>
                    <p class="message">{{ validateOptionCondition('gt', settingData.action.conditionGt) }}</p>
                  </div>
                </div>
                <div class="optionGroup">
                  <div class="label toCapitalize colorGrey">{{locale.max}}</div>
                  <div class="box">
                    <span class="checkbox onoff">
                      <input type="checkbox"
                        id="checkbox_condition_lt"
                        v-model="settingData.action.conditionLt"
                        @click="checkOptionCondition('lt', $event)">
                      <label for="checkbox_condition_lt"></label>
                    </span>
                    <div v-if="settingData.action.conditionLt">
                      <input
                        type="text"
                        class="input"
                        v-model="settingData.action.conditionLtVal"
                        @input="optionConditionVal('lt', $event)"
                        @focus="validateOptionCondition('lt', settingData.action.conditionLt)"> {{locale.option_condition_lt}}
                    </div>
                    <p class="message">{{ validateOptionCondition('lt', settingData.action.conditionLt) }}</p>
                  </div>
                </div>
                <div class="optionGroup">
                  <div class="label toCapitalize colorGrey">{{locale.specific}}</div>
                  <div class="box">
                    <span class="checkbox onoff">
                      <input type="checkbox"
                        id="checkbox_condition_specific"
                        v-model="settingData.action.conditionSpecific"
                        @click="checkOptionCondition('specific', $event)">
                      <label for="checkbox_condition_specific"></label>
                    </span>
                    <div v-if="settingData.action.conditionSpecific">
                      <input
                        type="text"
                        class="input sizeS"
                        v-model="settingData.action.conditionSpecificVal"
                        @input="optionConditionVal('specific', $event)"
                        @focus="validateOptionCondition('specific', settingData.action.conditionSpecific)"> {{locale.option_condition_specific}}
                      <p class="message">{{ validateOptionCondition('specific', settingData.action.conditionSpecific) }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- 옵션 선택 조건 -->
            <!-- 옵션 기본체크 설정 -->
            <div class="item">
              <div class="label toCapitalize f_medium">{{locale.option}}</div>
              <div class="label checkbox toCapitalize f_medium">
                <input type="checkbox" id="hasDefault" v-model="settingData.action.hasDefault" @change="setHasDefault(settingData.action.hasDefault)" />
                <label for="hasDefault">{{locale.set_default}}</label>
              </div>
              <div class="mb15">
                {{locale.font_size}}
                <select class="input select" v-model="settingData.action.valueFontSize">
                  <option
                    v-for="(size, index) in fontSize"
                    :key="index"
                    :value="`${size}`">
                    {{ size }}
                  </option>
                </select>
              </div>
              <div>
                <ul class="itemList">
                  <li v-for="(item, index) in settingData.action.item" :key="`checkbox_${index}`" class="listItem">
                    <!-- 게스트뷰 항목 label / 다국어 -->
                    <input type="text" class="input" v-model="item.label[activeLang]" @focusout="updateLabel(item, $event)" />
                    <!-- 어드민 항목 label -->
                    <input type="text" class="input input2" v-model="item.value">
                    <!-- 가격이 있으면 증감될 값 -->
                    <div class="setOptionPrice">
                      <span class="toCapitalize colorGrey">{{locale.price}}</span>
                      <input type="text" class="input input2" v-model="item.price">
                      <button v-if="supportPlu" type="button" class="btnPlu" @click="setPlu(item, index)">PLU</button>
                    </div>
                    <!-- 삭제 -->
                    <button type="button" class="btnRemove" @click="removeOption(settingData.action.item, index, settingData.action)">{{locale.delete}}</button>
                    <!-- 추가옵션 -->
                    <div class="setSubOption setOptionPrice">
                      <span class="toCapitalize colorGrey">{{locale.page_option_suboption}}</span>
                      <select class="input input2" v-model="item.subOption">
                        <option value="">{{locale.none}}</option>
                        <option v-for="o in optionMods"
                          :key="o.id"
                          :value="o.id"
                          :disabled="o.disabled">
                          {{o.setting.action.labelValue}}
                        </option>
                      </select>
                    </div>
                    <!-- 식별코드 -->
                    <div class="setOptionPrice">
                      <span class="checkbox toCapitalize colorGrey">
                        <input type="checkbox" :id="`option_${index}_pId`" v-model="item.pIdActive">
                        <label :for="`option_${index}_pId`">{{locale.product_id}}</label>
                      </span>
                      <input v-if="item.pIdActive" type="text" class="input input2" v-model="item.pId">
                    </div>
                    <!-- 식별코드타입 -->
                    <div v-if="item.pIdActive" class="setSubOption setOptionPrice">
                      <span class="toCapitalize colorGrey">{{locale.pidtype}}</span>
                      <select class="input input2" v-model="item.pIdTypeId" @change="setPidType(item)">
                        <option v-for="pid in pIdType"
                          :key="pid.id"
                          :value="pid.id">
                          {{pid.id === '#none' ? locale.none : pid.label}}
                        </option>
                      </select>
                    </div>
                  </li>
                </ul>
                <button type="button" class="btn btnFull btnWhite toCapitalize" @click="addOption(settingData.action)">{{locale.editor_action_addoption}}</button>
              </div>
            </div>
            <!-- //옵션 기본체크 설정 -->
          </div>
          <!--//기능:: checkbox -->
          <!-- 기능:: select -->
          <div v-if="name === 'select'">
            <div class="item">
              <div class="optionGroup">
                <div class="label toCapitalize colorGrey">{{locale.label}}</div>
                <div class="box itemList">
                  <!-- 게스트뷰 label -->
                  <input type="text" class="input" v-model="settingData.action.label[activeLang]" @focusout="updateLabel(settingData.action, $event)" />
                  <!-- 어드민 label -->
                  <input type="text" class="input input2" v-model="settingData.action.labelValue" />
                  <div class="mt10">
                    {{locale.font_size}}
                    <select class="input select" v-model="settingData.action.labelFontSize">
                      <option
                        v-for="(size, index) in fontSize"
                        :key="index"
                        :value="`${size}`">
                        {{ size }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div class="item">
              <div class="label toCapitalize f_medium">{{locale.option}}</div>
              <div class="mb15">
                {{locale.font_size}}
                <select class="input select" v-model="settingData.action.valueFontSize">
                  <option
                    v-for="(size, index) in fontSize"
                    :key="index"
                    :value="`${size}`">
                    {{ size }}
                  </option>
                </select>
              </div>
              <div class="box">
                <ul class="itemList">
                  <li v-for="(item, index) in settingData.action.item" :key="`checkbox_${index}`" class="listItem">
                    <!-- 게스트뷰 항목 label / 다국어 -->
                    <input type="text" class="input" v-model="item.label[activeLang]" @focusout="updateLabel(item, $event)" />
                    <!-- 어드민 항목 label -->
                    <input type="text" class="input input2" v-model="item.value">
                    <!-- 가격이 있으면 증감될 값 -->
                    <div class="setOptionPrice">
                      <span class="toCapitalize colorGrey">{{locale.price}}</span>
                      <input type="text" class="input input2" v-model="item.price">
                      <button v-if="supportPlu" type="button" class="btnPlu" @click="setPlu(item, index)">PLU</button>
                    </div>
                    <!-- 추가옵션 -->
                    <div class="setSubOption setOptionPrice">
                      <span class="toCapitalize colorGrey">{{locale.page_option_suboption}}</span>
                      <select class="input input2" v-model="item.subOption">
                        <option value="">{{locale.none}}</option>
                        <option v-for="o in optionMods"
                          :key="o.id"
                          :value="o.id"
                          :disabled="o.disabled">
                          {{o.setting.action.labelValue}}
                        </option>
                      </select>
                    </div>
                    <!-- 식별코드 -->
                    <div class="setOptionPrice">
                      <span class="checkbox toCapitalize colorGrey">
                        <input type="checkbox" :id="`option_${index}_pId`" v-model="item.pIdActive">
                        <label :for="`option_${index}_pId`">{{locale.product_id}}</label>
                      </span>
                      <input v-if="item.pIdActive" type="text" class="input input2" v-model="item.pId">
                    </div>
                    <!-- 식별코드타입 -->
                    <div v-if="item.pIdActive" class="setSubOption setOptionPrice">
                      <span class="toCapitalize colorGrey">{{locale.pidtype}}</span>
                      <select class="input input2" v-model="item.pIdTypeId" @change="setPidType(item)">
                        <option v-for="pid in pIdType"
                          :key="pid.id"
                          :value="pid.id">
                          {{pid.id === '#none' ? locale.none : pid.label}}
                        </option>
                      </select>
                    </div>
                    <!-- 삭제 -->
                    <button type="button" class="btnRemove" @click="removeOption(settingData.action.item, index, settingData.action)">{{locale.delete}}</button>
                  </li>
                </ul>
                <button type="button" class="btn btnFull btnWhite toCapitalize" @click="addOption(settingData.action)">{{locale.editor_action_addoption}}</button>
              </div>
            </div>
          </div>
          <!--//기능:: select -->
          <!-- 기능:: rate -->
          <div v-if="name === 'rate'">
            <div class="item">
              <div class="optionGroup">
                <div class="label toCapitalize colorGrey">{{locale.label}}</div>
                <div class="box itemList">
                  <!-- 게스트뷰 label -->
                  <input type="text" class="input" v-model="settingData.action.label[activeLang]" @focusout="updateLabel(settingData.action, $event)" />
                  <!-- 어드민 label -->
                  <input type="text" class="input input2" v-model="settingData.action.labelValue" /><div class="mt10">
                    {{locale.font_size}}
                    <select class="input select" v-model="settingData.action.labelFontSize">
                      <option
                        v-for="(size, index) in fontSize"
                        :key="index"
                        :value="`${size}`">
                        {{ size }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div class="item">
              <div class="optionGroup">
                <div class="label toCapitalize colorGrey">{{locale.count}}</div>
                <div class="box">
                  <input type="text" class="input" v-model="settingData.action.max" @input="setRate(settingData.action)" placeholder="3~10">
                  <p class="message">{{ validateRate(settingData.action.max) }}</p>
                </div>
              </div>
            </div>
            <div class="item">
              <div class="label toCapitalize f_medium">{{locale.design}}</div>
              <div class="optionGroup">
                <div class="label toCapitalize colorGrey">{{locale.shape}}</div>
                <div class="box" style="font-size: 1.5em;">
                  <div :class="{radioItem: true, active: settingData.action.type === 'star'}" data-item="5">
                    <input type="radio" id="rate_type_star" value="star" v-model="settingData.action.type">
                    <label for="rate_type_star"><img src="~@/assets/img/rate_star.svg" alt="" /></label>
                  </div>
                  <div :class="{radioItem: true, active: settingData.action.type === 'heart'}" data-item="5">
                    <input type="radio" id="rate_type_heart" value="heart" v-model="settingData.action.type">
                    <label for="rate_type_heart"><img src="~@/assets/img/rate_heart.svg" alt="" /></label>
                  </div>
                  <div :class="{radioItem: true, active: settingData.action.type === 'smile'}" data-item="5">
                    <input type="radio" id="rate_type_smile" value="smile" v-model="settingData.action.type">
                    <label for="rate_type_smile"><img src="~@/assets/img/rate_smile.svg" alt="" /></label>
                  </div>
                  <div :class="{radioItem: true, active: settingData.action.type === 'circle'}" data-item="5">
                    <input type="radio" id="rate_type_circle" value="circle" v-model="settingData.action.type">
                    <label for="rate_type_circle"><img src="~@/assets/img/rate_circle.svg" alt="" /></label>
                  </div>
                  <div :class="{radioItem: true, active: settingData.action.type === 'square'}" data-item="5">
                    <input type="radio" id="rate_type_square" value="square" v-model="settingData.action.type">
                    <label for="rate_type_square"><img src="~@/assets/img/rate_square.svg" alt="" /></label>
                  </div>
                </div>
              </div>
              <div class="optionGroup">
                <div class="label toCapitalize colorGrey">{{locale.color}}</div>
                <div class="box">
                  <div class="colorPreset" :class="{ active: openedColorPicker === 'action' }">
                    <div class="btnColorPicker"
                      @click.stop="toggleColorPicker('action', settingData.action.color)">
                      {{settingData.action.color}}
                      <i :style="{backgroundColor: settingData.action.color}"></i>
                    </div>
                    <sketch-picker v-if="openedColorPicker === 'action'"
                      :value="currentColor.color"
                      class="vc-sketch"
                      @input="onChangeColor"
                      @click.stop />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--//기능:: rate -->
          <!-- 기능:: quantity -->
          <div v-if="name === 'quantity'">
            <div class="item">
              <div class="label toCapitalize f_medium">{{locale.range}}</div>
              <div class="optionGroup">
                <div class="label toCapitalize colorGrey">{{`${locale.min}~${locale.max}`}}</div>
                <div class="box">
                  <div class="unit hasColumn">
                    <div class="unitColumn">
                      <input type="text" class="input"
                        v-model="settingData.action.min"
                        data-quantity="min"
                        :disabled="linkedProduct"
                        @input="setQuantity(settingData.action, 'min')"
                        @focusout="validateQuantity(settingData.action)" />
                    </div>
                    <div class="unitColumn">
                      <input type="text" class="input"
                        v-model="settingData.action.max"
                        data-quantity="max"
                        :disabled="linkedProduct"
                        @input="setQuantity(settingData.action, 'max')"
                        @focusout="validateQuantity(settingData.action)" />
                    </div>
                    <p class="message">{{ validateQuantity(settingData.action) }}</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="item">
              <div class="unit">
                <div class="checkbox label toCapitalize f_medium">
                  <input type="checkbox" id="quantity_price" @change="checkedPrice(settingData.action.price.isPrice)" v-model="settingData.action.price.isPrice">
                  <label for="quantity_price">{{`${locale.editor_display_price} (${locale.editor_price_about})`}}</label>
                </div>
                <div class="optionGroup">
                  <div class="label toCapitalize colorGrey">{{locale.price}}</div>
                  <div class="box">
                    <input type="text" class="input"
                      v-model="settingData.action.price.value"
                      :disabled="!settingData.action.price.isPrice || linkedProduct">
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- //기능:: quantity -->
          <!-- 기능:: datetime -->
          <div v-if="name === 'datetime'">
            <div class="item">
              <div class="checkbox toCapitalize f_medium">
                <input type="checkbox" name="datetime_active" id="active_datetime_asap"
                  v-model="settingData.action.asap.active"
                  :disabled="settingData.action.asap.active && (settingData.action.asap.active !== settingData.action.settime.active)">
                <label for="active_datetime_asap">{{locale.asap}}</label>
              </div>
            </div>
            <!-- 사용 설정 -->
            <div class="item">
              <div class="checkbox toCapitalize f_medium">
                <input type="checkbox" name="datetime_active" id="active_datetime_settime"
                  v-model="settingData.action.settime.active"
                  :disabled="settingData.action.settime.active && (settingData.action.asap.active !== settingData.action.settime.active)">
                <label for="active_datetime_settime">{{locale.editor_module_datetime}}</label>
              </div>
              <div class="optionCondition">
                <!-- 날짜 사용 -->
                <div class="optionGroup">
                  <div class="label toCapitalize colorGrey">{{locale.date}}</div>
                  <div class="box">
                    <div class="checkbox onoff">
                      <input type="checkbox" id="active_date" v-model="settingData.action.activeDate" :disabled="settingData.action.activeDate !== false && settingData.action.activeTime === false">
                      <label for="active_date">{{settingData.action.activeDate ? locale.enabled : locale.disabled}}</label>
                    </div>
                  </div>
                </div>
                <!-- //날짜 사용 -->
                <!-- 시간 사용 -->
                <div class="optionGroup">
                  <div class="label toCapitalize colorGrey">{{locale.time}}</div>
                  <div class="box">
                    <div class="mb10">
                      <div class="checkbox onoff">
                        <input type="checkbox" id="active_time" v-model="settingData.action.activeTime" :disabled="settingData.action.activeDate === false && settingData.action.activeTime !== false">
                        <label for="active_time">{{settingData.action.activeTime ? locale.enabled : locale.disabled}}</label>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- //시간 사용 -->
              </div>
            </div>
            <!-- //사용 설정 -->
            <!-- 범위 (절대값) -->
            <div class="item">
              <div class="checkbox toCapitalize f_medium">
                <input type="checkbox" id="calendarTerm" v-model="settingData.action.hasTerm" />
                <label for="calendarTerm">{{locale.setting_calendar_range}}</label>
              </div>
              <div v-if="settingData.action.hasTerm">
                <div class="optionGroup mt10">
                  <div class="label toCapitalize colorGrey">{{locale.start_date}}</div>
                  <div class="box">
                    <DatePicker
                      v-model="calendarRangeStart"
                      :masks="{input: dateFormat.toUpperCase()}"
                      :disabled-dates="calendarRangeStart"
                      :attributes="calendarRangeAttr">
                      <template v-slot="{ inputValue, togglePopover }">
                        <div>
                          <button
                            class="input btnCalendar"
                            @click="togglePopover()">
                            {{toFormat(settingData.action.dateFrom)}}
                          </button>
                        </div>
                      </template>
                    </DatePicker>
                  </div>
                </div>
                <div class="optionGroup mt10">
                  <div class="label toCapitalize colorGrey">{{locale.end_date}}</div>
                  <div class="box">
                    <DatePicker
                      v-model="calendarRangeEnd"
                      :masks="{input: dateFormat.toUpperCase()}"
                      :attributes="calendarRangeAttr"
                      :disabled-dates="calendarRangeEnd">
                      <template v-slot="{ inputValue, togglePopover }">
                        <div>
                          <button
                            class="input btnCalendar"
                            @click="togglePopover()">
                            {{toFormat(settingData.action.dateTo)}}
                          </button>
                        </div>
                      </template>
                    </DatePicker>
                  </div>
                </div>
              </div>
            </div>
            <!-- //범위 (절대값) -->
            <!-- 범위 (상대값) -->
            <div class="item">
              <div class="checkbox toCapitalize f_medium">
                <input type="checkbox" id="rangeNumber" v-model="settingData.action.hasRangeDay" />
                <label for="rangeNumber">{{locale.editor_setting_rangeday}}</label>
              </div>
              <div v-if="settingData.action.hasRangeDay">
                <div class="optionGroup mt10">
                  <div class="label toCapitalize colorGrey">{{locale.from_today}}</div>
                  <div class="box">
                    <input type="text" class="input mb10" v-model="settingData.action.rangeDayNumber">
                    <p class="sysMessage">{{locale.message_rangeday}}</p>
                  </div>
                </div>
              </div>
            </div>
            <!-- //범위 (절대값) -->
            <!-- 상세 설정 -->
            <div class="item">
              <div class="label toCapitalize f_medium">{{locale.setting_calendar_detail}}</div>
              <div class="optionCondition">
                <div class="optionGroup mt10">
                  <div class="label toCapitalize colorGrey">{{locale.past}}</div>
                  <div class="box">
                    <span class="checkbox onoff">
                      <input type="checkbox"
                        id="calendar_allowed_past"
                        v-model="settingData.action.allowedPast">
                      <label for="calendar_allowed_past">{{settingData.action.allowedPast ? locale.selectable : locale.not_selectable}}</label>
                    </span>
                  </div>
                </div>
                <div class="optionGroup">
                  <div class="label toCapitalize colorGrey">{{locale.today}}</div>
                  <div class="box">
                    <span class="checkbox onoff">
                      <input type="checkbox"
                        id="calendar_allowed_today"
                        v-model="settingData.action.allowedToday">
                      <label for="calendar_allowed_today">{{settingData.action.allowedToday ? locale.selectable : locale.not_selectable}}</label>
                    </span>
                  </div>
                </div>
                <div class="optionGroup">
                  <div class="label toCapitalize colorGrey">{{locale.date_of_stay_only}}</div>
                  <div class="box">
                    <span class="checkbox onoff">
                      <input type="checkbox"
                        id="calendar_allowed_stay"
                        v-model="settingData.action.allowedStay">
                      <label for="calendar_allowed_stay">{{settingData.action.allowedStay ? locale.enabled : locale.disabled}}</label>
                    </span>
                    <div class="mt5 mb10"><p class="sysMessage">{{locale.message_stay_information_only}}</p></div>
                  </div>
                </div>
              </div>
              <div class="optionGroup">
                <div class="label toCapitalize colorGrey">{{locale.day_of_the_week}}</div>
                <div class="box">
                  <div class="setCalendarDays">
                    <ul class="dayList">
                      <li v-for="(day, index) in settingData.action.dayOfWeek" :key="index">
                        <div class="day checkbox">
                          <input type="checkbox" name="available" :id="`available_calendar_${day.id}`" :val="day.id" v-model="day.available">
                          <label :for="`available_calendar_${day.id}`">{{locale[day.id]}}</label>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="optionGroup">
                <div class="label toCapitalize colorGrey">{{locale.not_selectable_days}}</div>
                <div class="box">
                  <DatePicker
                    color="orange"
                    :attributes="disabledAttr"
                    :value="null"
                    :disabled-dates="disabledDateView"
                    @dayclick="onDisabledDayClick">
                    <template v-slot="{ inputValue, togglePopover }">
                      <div>
                        <button
                          class="btn btnWhite btnFull"
                          @click="togglePopover()">
                          {{locale.setting}}
                        </button>
                      </div>
                    </template>
                  </DatePicker>
                  <div class="dayList"
                    v-if="settingData.action.disabledDays && settingData.action.disabledDays.length">
                    <div class="dayItem"
                      v-for="(day, i) in settingData.action.disabledDays"
                      :key="`${i}_${day.id}`">
                      {{toFormat(day.date)}}
                      <button class="btnDel" @click.stop="onDisabledDayClick(day)"><span class="blind">delete</span></button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- //상세 설정 -->
            <!-- 시간 범위 설정 -->
            <div v-if="settingData.action.settime.active" class="item">
              <div class="checkbox toCapitalize f_medium">
                <input type="checkbox" id="minuteTerm" v-model="settingData.action.hasRangeTime" />
                <label for="minuteTerm">{{locale.set_time_range}}</label>
              </div>
              <div v-if="settingData.action.hasRangeTime">
                <div class="optionGroup">
                  <div class="label toCapitalize colorGrey">{{locale.selectable_time}}</div>
                  <div class="box timeRange">
                    <span v-for="hh in settingData.action.rangeTimeNumber"
                      :key="hh.value"
                      class="timeRangeItem">
                      <input type="checkbox" :id="`range_time_${hh.value}`" v-model="hh.active">
                      <label :for="`range_time_${hh.value}`">{{hh.value}}</label>
                    </span>
                  </div>
                </div>
                <div class="optionGroup">
                  <div class="label toCapitalize colorGrey">{{locale.unit_of_minute}}</div>
                  <div class="box">
                    <select name="" id="" class="input" v-model="settingData.action.settime.time">
                      <option value="10">10</option>
                      <option value="15">15</option>
                      <option value="30">30</option>
                      <option value="60">60</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <!-- //시간 범위 설정 -->
          </div>
          <!-- //기능:: datetime -->
          <!--
            기능:: calendar
            datetime 모듈에 병합하여 더이상 업데이트 하지 않음
            기존 사용되는 사이트가 있기 때문에 모듈 자체는 유지
           -->
          <div v-if="name === 'calendar'">
            <div class="item">
              <div class="optionGroup">
                <div class="label toCapitalize colorGrey">{{locale.label}}</div>
                <div class="box">
                  <!-- 게스트뷰 label -->
                  <input type="text" class="input" v-model="settingData.action.label[activeLang]" @focusout="updateLabel(settingData.action, $event)" />
                  <!-- 어드민 label -->
                  <input type="text" class="input input2" v-model="settingData.action.labelValue" /><div class="mt10">
                    {{locale.font_size}}
                    <select class="input select" v-model="settingData.action.labelFontSize">
                      <option
                        v-for="(size, index) in fontSize"
                        :key="index"
                        :value="`${size}`">
                        {{ size }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div class="item">
              <div class="optionGroup">
                <div class="label toCapitalize colorGrey">{{locale.input_field}}</div>
                <div class="box">
                  <div>{{locale.font_size}}</div>
                  <select class="input select" v-model="settingData.action.valueFontSize">
                    <option
                      v-for="(size, index) in fontSize"
                      :key="index"
                      :value="`${size}`">
                      {{ size }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <!-- 범위 (절대값) -->
            <div class="item">
              <div class="checkbox toCapitalize f_medium">
                <input type="checkbox" id="calendarTerm" v-model="settingData.action.hasTerm" />
                <label for="calendarTerm">{{locale.setting_calendar_range}}</label>
              </div>
              <div v-if="settingData.action.hasTerm">
                <div class="optionGroup mt10">
                  <div class="label toCapitalize colorGrey">{{locale.start_date}}</div>
                  <div class="box">
                    <DatePicker
                      v-model="calendarRangeStart"
                      :masks="{input: dateFormat.toUpperCase()}"
                      :disabled-dates="calendarRangeStart"
                      :attributes="calendarRangeAttr">
                      <template v-slot="{ inputValue, togglePopover }">
                        <div>
                          <button
                            class="input btnCalendar"
                            @click="togglePopover()">
                            {{toFormat(settingData.action.dateFrom)}}
                          </button>
                        </div>
                      </template>
                    </DatePicker>
                  </div>
                </div>
                <div class="optionGroup mt10">
                  <div class="label toCapitalize colorGrey">{{locale.end_date}}</div>
                  <div class="box">
                    <DatePicker
                      v-model="calendarRangeEnd"
                      :masks="{input: dateFormat.toUpperCase()}"
                      :attributes="calendarRangeAttr"
                      :disabled-dates="calendarRangeEnd">
                      <template v-slot="{ inputValue, togglePopover }">
                        <div>
                          <button
                            class="input btnCalendar"
                            @click="togglePopover()">
                            {{toFormat(settingData.action.dateTo)}}
                          </button>
                        </div>
                      </template>
                    </DatePicker>
                  </div>
                </div>
              </div>
            </div>
            <!-- //범위 (절대값) -->
            <!-- 범위 (상대값) -->
            <div class="item">
              <div class="checkbox toCapitalize f_medium">
                <input type="checkbox" id="rangeNumber" v-model="settingData.action.hasRangeDay" />
                <label for="rangeNumber">{{locale.editor_setting_rangeday}}</label>
              </div>
              <div v-if="settingData.action.hasRangeDay">
                <div class="optionGroup mt10">
                  <div class="label toCapitalize colorGrey">{{locale.from_today}}</div>
                  <div class="box">
                    <input type="text" class="input mb10" v-model="settingData.action.rangeDayNumber">
                    <p class="sysMessage">{{locale.message_rangeday}}</p>
                  </div>
                </div>
              </div>
            </div>
            <!-- //범위 (절대값) -->
            <!-- 상세 설정 -->
            <div class="item">
              <div class="label toCapitalize f_medium">{{locale.setting_calendar_detail}}</div>
              <div class="optionCondition">
                <div class="optionGroup mt10">
                  <div class="label toCapitalize colorGrey">{{locale.past}}</div>
                  <div class="box">
                    <span class="checkbox onoff">
                      <input type="checkbox"
                        id="calendar_allowed_past"
                        v-model="settingData.action.allowedPast">
                      <label for="calendar_allowed_past">{{settingData.action.allowedPast ? locale.selectable : locale.not_selectable}}</label>
                    </span>
                  </div>
                </div>
                <div class="optionGroup">
                  <div class="label toCapitalize colorGrey">{{locale.today}}</div>
                  <div class="box">
                    <span class="checkbox onoff">
                      <input type="checkbox"
                        id="calendar_allowed_today"
                        v-model="settingData.action.allowedToday">
                      <label for="calendar_allowed_today">{{settingData.action.allowedToday ? locale.selectable : locale.not_selectable}}</label>
                    </span>
                  </div>
                </div>
                <div class="optionGroup">
                  <div class="label toCapitalize colorGrey">{{locale.date_of_stay_only}}</div>
                  <div class="box">
                    <span class="checkbox onoff">
                      <input type="checkbox"
                        id="calendar_allowed_stay"
                        v-model="settingData.action.allowedStay">
                      <label for="calendar_allowed_stay">{{settingData.action.allowedStay ? locale.enabled : locale.disabled}}</label>
                    </span>
                    <div class="mt5 mb10"><p class="sysMessage">{{locale.message_stay_information_only}}</p></div>
                  </div>
                </div>
              </div>
              <div class="optionGroup">
                <div class="label toCapitalize colorGrey">{{locale.day_of_the_week}}</div>
                <div class="box">
                  <div class="setCalendarDays">
                    <ul class="dayList">
                      <li v-for="(day, index) in settingData.action.dayOfWeek" :key="index">
                        <div class="day checkbox">
                          <input type="checkbox" name="available" :id="`available_calendar_${day.id}`" :val="day.id" v-model="day.available">
                          <label :for="`available_calendar_${day.id}`">{{locale[day.id]}}</label>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="optionGroup">
                <div class="label toCapitalize colorGrey">{{locale.not_selectable_days}}</div>
                <div class="box">
                  <!-- <DatePicker
                    :mode="'multiple'"
                    :attributes="disabledAttr"
                    :value="null"
                    @dayclick="onDisabledDayClick" /> -->
                  <DatePicker
                    color="orange"
                    :attributes="disabledAttr"
                    :value="null"
                    :disabled-dates="disabledDateView"
                    @dayclick="onDisabledDayClick">
                    <template v-slot="{ inputValue, togglePopover }">
                      <div>
                        <button
                          class="btn btnWhite btnFull"
                          @click="togglePopover()">
                          {{locale.setting}}
                        </button>
                      </div>
                    </template>
                  </DatePicker>
                  <div class="dayList"
                    v-if="settingData.action.disabledDays.length">
                    <div class="dayItem"
                      v-for="(day, i) in settingData.action.disabledDays"
                      :key="`${i}_${day.id}`">
                      {{toFormat(day.date)}}
                      <button class="btnDel" @click.stop="onDisabledDayClick(day)"><span class="blind">delete</span></button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- //상세 설정 -->
          </div>
          <!-- //기능:: calendar -->
          <!-- 기능:: signaturepad -->
          <div v-if="name === 'signaturepad'" class="item">
            <div class="optionGroup">
              <div class="label toCapitalize colorGrey">{{locale.label}}</div>
              <div class="box itemList">
                <!-- 게스트뷰 label -->
                <input type="text" class="input" v-model="settingData.action.label[activeLang]" @focusout="updateLabel(settingData.action, $event)" />
                <!-- 어드민 label -->
                <input type="text" class="input input2" v-model="settingData.action.labelValue" /><div class="mt10">
                    {{locale.font_size}}
                    <select class="input select" v-model="settingData.action.labelFontSize">
                      <option
                        v-for="(size, index) in fontSize"
                        :key="index"
                        :value="`${size}`">
                        {{ size }}
                      </option>
                    </select>
                  </div>
              </div>
            </div>
          </div>
          <!--//기능:: signaturepad -->
          <!-- 기능:: cert -->
          <div v-if="name === 'cert'" class="item">
            <div class="optionGroup">
              <div class="label toCapitalize colorGrey">{{locale.label}}</div>
              <div class="box">
                <!-- 게스트뷰 label -->
                <input type="text" class="input" v-model="settingData.action.label[activeLang]" @focusout="updateLabel(settingData.action, $event)" />
                <!-- 어드민 label -->
                <input type="text" class="input input2" v-model="settingData.action.labelValue" /><div class="mt10">
                    {{locale.font_size}}
                    <select class="input select" v-model="settingData.action.labelFontSize">
                      <option
                        v-for="(size, index) in fontSize"
                        :key="index"
                        :value="`${size}`">
                        {{ size }}
                      </option>
                    </select>
                  </div>
              </div>
            </div>
          </div>
          <!--//기능:: cert -->
          <!-- 기능:: postcode -->
          <div v-if="name === 'postcode'" class="item">
            <div class="optionGroup">
              <div class="label toCapitalize colorGrey">{{locale.label}}</div>
              <div class="box">
                <!-- 게스트뷰 label -->
                <input type="text" class="input" v-model="settingData.action.label[activeLang]" @focusout="updateLabel(settingData.action, $event)" />
                <!-- 어드민 label -->
                <input type="text" class="input input2" v-model="settingData.action.labelValue" /><div class="mt10">
                    {{locale.font_size}}
                    <select class="input select" v-model="settingData.action.labelFontSize">
                      <option
                        v-for="(size, index) in fontSize"
                        :key="index"
                        :value="`${size}`">
                        {{ size }}
                      </option>
                    </select>
                  </div>
              </div>
            </div>
          </div>
          <!--//기능:: postcode -->
        </div>
      </div>
      <!-- //action setting options -->
      <!-- detail setting options -->
      <div v-else-if="settingType === 'detail'" class="listBox">
        <div v-if="settingData.detail === null" class="requireMessage">{{locale.editor_not_support}}</div>
        <div v-else>
          <div v-if="settingTarget !== 'column'" class="requireMessage">{{locale.editor_click_settingbtn}}</div>
          <div v-else>
            <!-- <div v-for="opt in detailList" :key="opt.name" class="item"> -->
            <div v-for="opt in detailList.filter(x => x.name !== 'upload')" :key="opt.name" class="item">
              <!-- detail:: instagramfeed -->
              <div v-if="opt.name === 'instagramfeed'">
                <div class="label toCapitalize f_medium">{{locale.instagramfeed}}</div>
                <div class="optionGroup">
                  <div class="label toCapitalize colorGrey">미디어 개수</div>
                  <div class="box">
                    <input type="text" class="input" placeholder="number only" v-model="detailData.instagramfeed.items" @input="setNumber(detailData.instagramfeed, 'items')" />
                  </div>
                </div>
                <div class="optionGroup">
                  <div class="label toCapitalize colorGrey">미디어 컬럼</div>
                  <div class="box">
                    <input type="text" class="input" placeholder="number only" v-model="detailData.instagramfeed.cols" @input="setNumber(detailData.instagramfeed, 'cols')" />
                  </div>
                </div>
                <div class="optionGroup">
                  <div class="label toCapitalize colorGrey">미디어 간격</div>
                  <div class="box">
                    <div :class="{radioItem: true, active: detailData.instagramfeed.margin === '0'}">
                      <input type="radio" name="setting_detail_instagramfeed_margin" id="setting_detail_instagramfeed_margin_0" value="0" v-model="detailData.instagramfeed.margin">
                      <label for="setting_detail_instagramfeed_margin_0">{{locale.none}}</label>
                    </div>
                    <div :class="{radioItem: true, active: detailData.instagramfeed.margin === '4'}">
                      <input type="radio" name="setting_detail_instagramfeed_margin" id="setting_detail_instagramfeed_margin_4" value="4" v-model="detailData.instagramfeed.margin">
                      <label for="setting_detail_instagramfeed_margin_4">{{locale.default}}</label>
                    </div>
                    <div :class="{radioItem: true, active: detailData.instagramfeed.margin === '8'}">
                      <input type="radio" name="setting_detail_instagramfeed_margin" id="setting_detail_instagramfeed_margin_8" value="8" v-model="detailData.instagramfeed.margin">
                      <label for="setting_detail_instagramfeed_margin_8">{{locale.editor_setting_wide}}</label>
                    </div>
                  </div>
                </div>
                <div class="optionCondition">
                  <div class="optionGroup feedLayout">
                    <div class="label toCapitalize colorGrey">캡션 위치</div>
                    <div class="box">
                      <div class="mb5">
                        <div class="checkbox radio">
                          <input type="radio" name="setting_detail_instagramfeed_caption" id="setting_detail_instagramfeed_caption_none" value="none" v-model="detailData.instagramfeed.caption">
                          <label for="setting_detail_instagramfeed_caption_none">표시 안함</label>
                        </div>
                      </div>
                      <div class="mb5">
                        <div class="checkbox radio">
                          <input type="radio" name="setting_detail_instagramfeed_caption" id="setting_detail_instagramfeed_caption_overlay" value="overlay" v-model="detailData.instagramfeed.caption">
                          <label for="setting_detail_instagramfeed_caption_overlay">이미지에 겹쳐서</label>
                        </div>
                      </div>
                      <div>
                        <div class="checkbox radio">
                          <input type="radio" name="setting_detail_instagramfeed_caption" id="setting_detail_instagramfeed_caption_bottom" value="bottom" v-model="detailData.instagramfeed.caption">
                          <label for="setting_detail_instagramfeed_caption_bottom">이미지 아래에</label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- detail:: instagramfeed -->
              <!-- detail:: division -->
              <div v-if="opt.name === 'division'">
                <div class="label toCapitalize f_medium">{{locale.editor_module_line}}</div>
                <div class="optionGroup">
                  <div class="label toCapitalize colorGrey">{{locale.width}}</div>
                  <div class="box">
                    <input type="text" class="input" placeholder="number only" v-model="detailData.division.width" @input="setNumber(detailData.division, 'width')" />
                  </div>
                </div>
                <div class="optionGroup">
                  <div class="label toCapitalize colorGrey">{{locale.style}}</div>
                  <div class="box">
                    <div :class="{radioItem: true, active: detailData.division.style === 'solid'}">
                      <input type="radio" name="setting_division_style" id="setting_division_solid" value="solid" v-model="detailData.division.style">
                      <label for="setting_division_solid">{{locale.editor_setting_solid}}</label>
                    </div>
                    <div :class="{radioItem: true, active: detailData.division.style === 'dotted'}">
                      <input type="radio" name="setting_division_style" id="setting_division_dotted" value="dotted" v-model="detailData.division.style">
                      <label for="setting_division_dotted">{{locale.editor_setting_dotted}}</label>
                    </div>
                    <div :class="{radioItem: true, active: detailData.division.style === 'dashed'}">
                      <input type="radio" name="setting_division_style" id="setting_division_dashed" value="dashed" v-model="detailData.division.style">
                      <label for="setting_division_dashed">{{locale.editor_setting_dashed}}</label>
                    </div>
                  </div>
                </div>
                <div class="optionGroup">
                  <div class="label toCapitalize colorGrey">{{locale.color}}</div>
                  <div class="box">
                    <div class="colorPreset" :class="{ active: openedColorPicker === 'division' }">
                      <div class="btnColorPicker"
                        @click.stop="toggleColorPicker('division', detailData.division.color)">
                        {{detailData.division.color}}
                        <i :style="{backgroundColor: detailData.division.color}"></i>
                      </div>
                      <sketch-picker v-if="openedColorPicker === 'division'"
                        :value="currentColor.color"
                        class="vc-sketch"
                        @input="onChangeColor"
                        @click.stop />
                    </div>
                  </div>
                </div>
              </div>
              <!-- //detail:: division -->
              <!-- detail:: carousel -->
              <div v-if="opt.name === 'carousel'">
                <div>
                  <div class="checkbox toCapitalize f_medium">
                    <input type="checkbox" id="check_carousel_auto" v-model="detailData.carousel.auto">
                    <label for="check_carousel_auto">{{locale.editor_auto_slide}}</label>
                  </div>
                  <div class="optionGroup">
                    <div class="label toCapitalize colorGrey">{{locale.settime}}</div>
                    <div class="box">
                      <input type="text" class="input" v-model="detailData.carousel.duration">
                      <p class="message infoMessage">1000 = 1sec</p>
                    </div>
                  </div>
                  <div class="optionGroup">
                    <div class="label toCapitalize colorGrey">{{locale.align}}</div>
                    <div class="box setAlignItems">
                      <div :class="{radioItem: true, active: !detailData.carousel.alignment || detailData.carousel.alignment === 'flex-start'}">
                        <input type="radio" name="setting_align_carousel" id="setting_align_carousel_flex-start" value="flex-start" v-model="detailData.carousel.alignment">
                        <label for="setting_align_carousel_flex-start">start</label>
                      </div>
                      <div :class="{radioItem: true, active: detailData.carousel.alignment === 'center'}">
                        <input type="radio" name="setting_align_carousel" id="setting_align_carousel_flex-center" value="center" v-model="detailData.carousel.alignment">
                        <label for="setting_align_carousel_flex-center">center</label>
                      </div>
                      <div :class="{radioItem: true, active: detailData.carousel.alignment === 'flex-end'}">
                        <input type="radio" name="setting_align_carousel" id="setting_align_carousel_flex-end" value="flex-end" v-model="detailData.carousel.alignment">
                        <label for="setting_align_carousel_flex-end">end</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- //detail:: carousel -->
              <!-- detail:: link -->
              <div v-if="opt.name === 'link'">
                <div class="checkbox toCapitalize f_medium">
                  <input type="checkbox" id="check_detail_link" v-model="detailData.link.active">
                  <label for="check_detail_link">{{locale.link}}</label>
                </div>
                <div v-if="detailData.link.active" class="optionGroup">
                  <SetLink :link="detailData.link" />
                </div>
              </div>
              <!-- //detail:: link -->
              <!-- detail:: upload
              <div v-if="opt.name === 'upload'">
                <div class="checkbox toCapitalize f_medium" :class="{disabled: detailData.link.active}">
                  <input type="checkbox" id="check_detail_upload" :checked="{false: detailData.link.active}" :disabled="detailData.link.active" v-model="detailData.upload.active">
                  <label for="check_detail_upload">{{locale.upload_image}}</label>
                </div>
                <div v-if="detailData.upload.active">
                  <div class="optionGroup mb15">
                    <div class="label colorGrey">{{locale.upload_max}}</div>
                    <div class="box"><input type="text" class="input input2" v-model="detailData.upload.count"></div>
                  </div>
                  <div class="optionGroup mb15">
                    <div class="label toCapitalize colorGrey">{{locale.label}}</div>
                    <div class="box">
                      <input type="text" class="input" v-model="detailData.upload.label[activeLang]" @focusout="updateDetailLabel(detailData.upload, $event)" />
                      <input type="text" class="input input2" v-model="detailData.upload.labelValue" />
                    </div>
                  </div>
                  <div class="optionGroup">
                    <div class="label colorGrey">{{locale.upload_display}}</div>
                    <div class="box">
                      <div class="mb5">
                        <span class="checkbox radio">
                          <input type="radio" name="detail_upload_preview" id="detail_upload_preview_image" value="image" v-model="detailData.upload.previewType">
                          <label for="detail_upload_preview_image">{{locale.image}}</label>
                        </span>
                      </div>
                      <div>
                        <span class="checkbox radio">
                          <input type="radio" name="detail_upload_preview" id="detail_upload_preview_filename" value="filename" v-model="detailData.upload.previewType">
                          <label for="detail_upload_preview_filename">{{locale.filename}}</label>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              //detail:: upload -->
              <!-- detail:: qrcode -->
              <div v-if="opt.name === 'qrcode'">
                <div class="label toCapitalize f_medium">{{locale.qrcode}} {{locale.link}}</div>
                <div class="addedOption mt15">
                  <SetLink :link="detailData.qrcode" />
                </div>
              </div>
              <div v-if="opt.name === 'qrcodeExpired'">
                <div class="checkbox toCapitalize f_medium">
                  <input type="checkbox" id="check_qrcode_expired" v-model="detailData.qrcodeExpired.isActive">
                  <label for="check_qrcode_expired">{{locale.qrcode}} URL 유효일</label>
                </div>
                <div class="mt5"><p class="sysMessage">QR이미지와 함께 해당 url까지 접근 유효기간이 생깁니다.</p></div>
                <div v-if="detailData.qrcodeExpired.isActive" class="mt5">
                  <input type="text" class="input" v-model="detailData.qrcodeExpired.day" @input="inputNumber(['detailData', 'qrcodeExpired', 'day'], detailData.qrcodeExpired.day)">
                </div>
              </div>
              <div v-if="opt.name === 'qrcodeSize'">
                <div class="label toCapitalize f_medium">{{locale.qrcode}} {{locale.size}}</div>
                <div class="mt5">
                  <input type="text" class="input" v-model="detailData.qrcodeSize.size">
                </div>
                <div class="mt5"><p class="sysMessage">{{locale.message_qrcode_size}}</p></div>
              </div>
              <!-- //detail:: qrcode -->
              <!-- detail:: smartvoice -->
              <div v-if="opt.name === 'smartvoice'">
                <div class="label toCapitalize f_medium">{{locale.smartvoice}}</div>
                <div  class="optionGroup">
                  <SmartVoice :locale="locale" :smartvoice="detailData.smartvoice" />
                </div>
              </div>
              <!-- //detail:: smartvoice -->
              <!-- detail:: button -->
              <div v-if="opt.name === 'button'">
                <div class="optionGroup">
                  <div class="label toCapitalize f_medium">{{locale.type}}</div>
                  <div class="box" @change="updateSubmits">
                    <span class="checkbox radio">
                      <input type="radio" name="button_link_type" id="button_link_type_link" value="link" v-model="detailData.button.type">
                      <label for="button_link_type_link" class="label">{{locale.link}}</label>
                    </span>
                    <span class="checkbox radio">
                      <input type="radio" name="button_link_type" id="button_link_type_submit" value="submit" v-model="detailData.button.type">
                      <label for="button_link_type_submit" class="label">{{locale.submit}}</label>
                    </span>
                  </div>
                </div>
                <div v-if="detailData.button.type === 'link'" class="addedOption mt15">
                  <SetLink :link="detailData.button.link" />
                </div>
              </div>
              <!-- //detail:: button -->
              <!-- detail:: color -->
              <div v-if="opt.name === 'color'">
                <div class="checkbox toCapitalize f_medium">
                  <input type="checkbox" id="check_detail_color" v-model="detailData.color.active">
                  <label for="check_detail_color">{{locale.color}}</label>
                </div>
                <div v-if="detailData.color.active" class="optionGroup">
                  <div class="label toCapitalize colorGrey">{{locale.color}}</div>
                  <div class="box">
                    <div class="colorPreset" :class="{ active: openedColorPicker === 'color' }">
                      <div class="btnColorPicker"
                        @click.stop="toggleColorPicker('color', detailData.color.color)">
                        {{detailData.color.color}}
                        <i :style="{backgroundColor: detailData.color.color}"></i>
                      </div>
                      <sketch-picker v-if="openedColorPicker === 'color'"
                        :value="currentColor.color"
                        class="vc-sketch"
                        @input="onChangeColor"
                        @click.stop />
                    </div>
                  </div>
                </div>
              </div>
              <!-- //detail:: color -->
              <!-- detail:: colorHex -->
              <div v-if="opt.name === 'colorHex'">
                <div class="checkbox toCapitalize f_medium">
                  <input type="checkbox" id="check_detail_color" v-model="detailData.colorHex.active">
                  <label for="check_detail_color">{{locale.color}}</label>
                </div>
                <div v-if="detailData.colorHex.active" class="optionGroup">
                  <div class="label toCapitalize colorGrey">{{locale.color}}</div>
                  <div class="box">
                    <div class="colorPreset" :class="{ active: openedColorPicker === 'colorHex' }">
                      <div class="btnColorPicker"
                        @click.stop="toggleColorPicker('colorHex', detailData.colorHex.color)">
                        {{detailData.colorHex.color}}
                        <i :style="{backgroundColor: detailData.colorHex.color}"></i>
                      </div>
                      <sketch-picker v-if="openedColorPicker === 'colorHex'"
                        :value="currentColor.color"
                        class="vc-sketch"
                        @input="onChangeColor"
                        @click.stop />
                    </div>
                  </div>
                </div>
              </div>
              <!-- //detail:: colorHex -->
              <!-- detail:: background -->
              <div v-if="opt.name === 'background'">
                <div class="checkbox toCapitalize f_medium">
                  <input type="checkbox" id="check_detail_background" v-model="detailData.background.active">
                  <label for="check_detail_background">{{locale.background}}</label>
                </div>
                <div v-if="detailData.background.active">
                  <div class="optionGroup">
                    <div class="label toCapitalize colorGrey">{{locale.color}}</div>
                    <div class="box">
                      <div class="colorPreset" :class="{ active: openedColorPicker === 'background' }">
                        <div class="btnColorPicker"
                          @click.stop="toggleColorPicker('background', detailData.background.color)">
                          {{detailData.background.color}}
                          <i :style="{backgroundColor: detailData.background.color}"></i>
                        </div>
                        <sketch-picker v-if="openedColorPicker === 'background'"
                          :value="currentColor.color"
                          class="vc-sketch"
                          @input="onChangeColor"
                          @click.stop />
                      </div>
                      <div v-if="settingData.layout.background.value !== ''">
                        <span class="checkbox small">
                          <input type="checkbox" id="detail_colorOverlay" v-model="detailData.background.overlay">
                          <label for="detail_colorOverlay">{{locale.overlay_color}}</label>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="optionGroup">
                    <div class="label toCapitalize colorGrey">{{locale.image}}</div>
                    <div class="box">
                      <div v-if="detailData.background.value === ''">
                        <input type="file" id="setting_detail_uploadimage" @change="uploadImage(detailData.background, $event)">
                        <label for="setting_detail_uploadimage" class="btn btnFull btnWhite">upload</label>
                      </div>
                      <div v-else>
                        <div class="bgThumb">
                          <img :src="detailData.background.value" alt="" />
                          <button type="button" class="delThumb" @click="deleteImage(detailData.background)"><img src="~@/assets/img/ico_close.svg" alt=""></button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- 배경이미지 옵션 -->
                  <div v-if="detailData.background.value !== ''">
                    <div class="optionGroup">
                      <div class="label toCapitalize colorGrey">{{locale.editor_setting_repeat}}</div>
                      <div class="box" data-item="4">
                        <div :class="{radioItem: true, active: detailData.background.repeat === 'no-repeat'}">
                          <input type="radio" name="detail_background_repeat" id="detail_background_repeat_n" value="no-repeat" v-model="detailData.background.repeat">
                          <label for="detail_background_repeat_n">{{locale.none}}</label>
                        </div>
                        <div :class="{radioItem: true, active: detailData.background.repeat === 'repeat-x'}">
                          <input type="radio" name="detail_background_repeat" id="detail_background_repeat_x" value="repeat-x" v-model="detailData.background.repeat">
                          <label for="detail_background_repeat_x">{{locale.editor_setting_repeat_x}}</label>
                        </div>
                        <div :class="{radioItem: true, active: detailData.background.repeat === 'repeat-y'}">
                          <input type="radio" name="detail_background_repeat" id="detail_background_repeat_y" value="repeat-y" v-model="detailData.background.repeat">
                          <label for="detail_background_repeat_y">{{locale.editor_setting_repeat_y}}</label>
                        </div>
                        <div :class="{radioItem: true, active: detailData.background.repeat === 'repeat'}">
                          <input type="radio" name="detail_background_repeat" id="detail_background_repeat_xy" value="repeat" v-model="detailData.background.repeat">
                          <label for="detail_background_repeat_xy">{{locale.editor_setting_repeat_xy}}</label>
                        </div>
                      </div>
                    </div>
                    <div class="optionGroup">
                      <div class="label toCapitalize colorGrey">{{locale.editor_setting_size}}</div>
                      <div class="box">
                        <div :class="{radioItem: true, active: detailData.background.size === 'auto'}">
                          <input type="radio" name="detail_background_size" id="detail_background_size_auto" value="auto" v-model="detailData.background.size">
                          <label for="detail_background_size_auto">{{locale.editor_setting_size_original}}</label>
                        </div>
                        <div :class="{radioItem: true, active: detailData.background.size === 'cover'}">
                          <input type="radio" name="detail_background_size" id="detail_background_size_cover" value="cover" v-model="detailData.background.size">
                          <label for="detail_background_size_cover">{{locale.editor_setting_size_cover}}</label>
                        </div>
                        <div :class="{radioItem: true, active: detailData.background.size === 'contain'}">
                          <input type="radio" name="detail_background_size" id="detail_background_size_contain" value="contain" v-model="detailData.background.size">
                          <label for="detail_background_size_contain">{{locale.editor_setting_size_contain}}</label>
                        </div>
                      </div>
                    </div>
                    <div class="optionGroup">
                      <div class="label toCapitalize colorGrey">{{locale.editor_setting_position}}</div>
                      <div class="box spot9">
                        <div :class="{radioItem: true, active: detailData.background.position === '0 0'}">
                          <input type="radio" name="detail_background_pos" id="detail_background_pos_0" value="0 0" v-model="detailData.background.position">
                          <label for="detail_background_pos_0"></label>
                        </div>
                        <div :class="{radioItem: true, active: detailData.background.position === '50% 0'}">
                          <input type="radio" name="detail_background_pos" id="detail_background_pos_1" value="50% 0" v-model="detailData.background.position">
                          <label for="detail_background_pos_1"></label>
                        </div>
                        <div :class="{radioItem: true, active: detailData.background.position === '100% 0'}">
                          <input type="radio" name="detail_background_pos" id="detail_background_pos_2" value="100% 0" v-model="detailData.background.position">
                          <label for="detail_background_pos_2"></label>
                        </div>
                        <div :class="{radioItem: true, active: detailData.background.position === '0 50%'}">
                          <input type="radio" name="detail_background_pos" id="detail_background_pos_3" value="0 50%" v-model="detailData.background.position">
                          <label for="detail_background_pos_3"></label>
                        </div>
                        <div :class="{radioItem: true, active: detailData.background.position === '50% 50%'}">
                          <input type="radio" name="detail_background_pos" id="detail_background_pos_4" value="50% 50%" v-model="detailData.background.position">
                          <label for="detail_background_pos_4"></label>
                        </div>
                        <div :class="{radioItem: true, active: detailData.background.position === '100% 50%'}">
                          <input type="radio" name="detail_background_pos" id="detail_background_pos_5" value="100% 50%" v-model="detailData.background.position">
                          <label for="detail_background_pos_5"></label>
                        </div>
                        <div :class="{radioItem: true, active: detailData.background.position === '0 100%'}">
                          <input type="radio" name="detail_background_pos" id="detail_background_pos_6" value="0 100%" v-model="detailData.background.position">
                          <label for="detail_background_pos_6"></label>
                        </div>
                        <div :class="{radioItem: true, active: detailData.background.position === '50% 100%'}">
                          <input type="radio" name="detail_background_pos" id="detail_background_pos_7" value="50% 100%" v-model="detailData.background.position">
                          <label for="detail_background_pos_7"></label>
                        </div>
                        <div :class="{radioItem: true, active: detailData.background.position === '100% 100%'}">
                          <input type="radio" name="detail_background_pos" id="detail_background_pos_8" value="100% 100%" v-model="detailData.background.position">
                          <label for="detail_background_pos_8"></label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- //배경이미지 옵션 -->
                </div>
              </div>
              <!-- //detail:: background -->
              <!-- detail:: border -->
              <div v-if="opt.name === 'border'">
                <div class="checkbox toCapitalize f_medium">
                  <input type="checkbox" id="check_detail_border" v-model="detailData.border.active">
                  <label for="check_detail_border">{{locale.border}}</label>
                </div>
                <div v-if="detailData.border.active">
                  <div class="optionGroup">
                    <div class="label toCapitalize colorGrey">{{locale.style}}</div>
                    <div class="box">
                      <div :class="{radioItem: true, active: detailData.border.style === 'solid'}">
                        <input type="radio" name="setting_border_style" id="setting_border_solid" value="solid" v-model="detailData.border.style">
                        <label for="setting_border_solid">{{locale.editor_setting_solid}}</label>
                      </div>
                      <div :class="{radioItem: true, active: detailData.border.style === 'dotted'}">
                        <input type="radio" name="setting_border_style" id="setting_border_dotted" value="dotted" v-model="detailData.border.style">
                        <label for="setting_border_dotted">{{locale.editor_setting_dotted}}</label>
                      </div>
                      <div :class="{radioItem: true, active: detailData.border.style === 'dashed'}">
                        <input type="radio" name="setting_border_style" id="setting_border_dashed" value="dashed" v-model="detailData.border.style">
                        <label for="setting_border_dashed">{{locale.editor_setting_dashed}}</label>
                      </div>
                    </div>
                  </div>
                  <div class="optionGroup">
                    <div class="label toCapitalize colorGrey">{{locale.color}}</div>
                    <div class="box">
                      <div class="colorPreset" :class="{ active: openedColorPicker === 'border' }">
                        <div class="btnColorPicker"
                          @click.stop="toggleColorPicker('border', detailData.border.color)">
                          {{detailData.border.color}}
                          <i :style="{backgroundColor: detailData.border.color}"></i>
                        </div>
                        <sketch-picker v-if="openedColorPicker === 'border'"
                          :value="currentColor.color"
                          class="vc-sketch"
                          @input="onChangeColor"
                          @click.stop />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- //detail:: border -->
              <!-- detail:: text color -->
              <div v-if="opt.name === 'text'">
                <div class="checkbox toCapitalize f_medium">
                  <input type="checkbox" id="check_detail_text" v-model="detailData.text.active">
                  <label for="check_detail_text">{{locale.text}}</label>
                </div>
                <div v-if="detailData.text.active" class="optionGroup">
                  <div class="label toCapitalize colorGrey">{{locale.color}}</div>
                  <div class="box">
                    <div class="colorPreset" :class="{ active: openedColorPicker === 'text' }">
                      <div class="btnColorPicker"
                        @click.stop="toggleColorPicker('text', detailData.text.color)">
                        {{detailData.text.color}}
                        <i :style="{backgroundColor: detailData.text.color}"></i>
                      </div>
                      <sketch-picker v-if="openedColorPicker === 'text'"
                        :value="currentColor.color"
                        class="vc-sketch"
                        @input="onChangeColor"
                        @click.stop />
                    </div>
                  </div>
                </div>
              </div>
              <!-- //detail:: text color -->
              <!-- detail:: smartkey -->
              <div v-if="opt.name === 'smartkey'">
                <!-- <div class="label toCapitalize f_medium">{{locale.editor_module_smartkey}}</div> -->
                <div class="mb15">
                  <div class="checkbox toCapitalize f_medium">
                    <input type="checkbox" id="check_smartkey_remote" v-model="detailData.smartkey.remotekey">
                    <label for="check_smartkey_remote">{{ locale.use_remotekey }}</label>
                  </div>
                </div>
                <div class="optionGroup">
                  <div class="label toCapitalize colorGrey">{{locale.font_size}}</div>
                  <div class="box">
                    <select class="input select" v-model="detailData.smartkey.size">
                      <option
                        v-for="(size, index) in fontSize"
                        :key="index"
                        :value="`${size}`">
                        {{ size }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="optionGroup">
                  <div class="label toCapitalize colorGrey">{{locale.align}}</div>
                  <div class="box setTextAlign">
                    <div :class="{radioItem: true, active: detailData.smartkey.align === 'left'}">
                      <input type="radio" name="smartkey_align" id="smartkey_align_left" value="left" v-model="detailData.smartkey.align">
                      <label for="smartkey_align_left">start</label>
                    </div>
                    <div :class="{radioItem: true, active: detailData.smartkey.align === 'center'}">
                      <input type="radio" name="smartkey_align" id="smartkey_align_center" value="center" v-model="detailData.smartkey.align">
                      <label for="smartkey_align_center">center</label>
                    </div>
                    <div :class="{radioItem: true, active: detailData.smartkey.align === 'right'}">
                      <input type="radio" name="smartkey_align" id="smartkey_align_right" value="right" v-model="detailData.smartkey.align">
                      <label for="smartkey_align_right">end</label>
                    </div>
                  </div>
                </div>
              </div>
              <!-- //detail:: smartkey -->
              <!-- detail:: smartkey remote -->
              <div v-if="opt.name === 'remotekey'">
                <div class="optionGroup">
                  <div class="label toCapitalize colorGrey">{{ locale.mobilekey_margin_remotekey }}</div>
                  <div class="box">
                    <div :class="{radioItem: true, active: detailData.remotekey.margin === '0'}">
                      <input type="radio" name="setting_detail_remotekey_margin" id="setting_detail_remotekey_margin0" value="0" v-model="detailData.remotekey.margin">
                      <label for="setting_detail_remotekey_margin0">{{locale.none}}</label>
                    </div>
                    <div :class="{radioItem: true, active: detailData.remotekey.margin === '15'}">
                      <input type="radio" name="setting_detail_remotekey_margin" id="setting_detail_remotekey_margin15" value="15" v-model="detailData.remotekey.margin">
                      <label for="setting_detail_remotekey_margin15">{{locale.default}}</label>
                    </div>
                    <div :class="{radioItem: true, active: detailData.remotekeymargin === '30'}">
                      <input type="radio" name="setting_detail_remotekey_margin" id="setting_detail_remotekey_margin30" value="30" v-model="detailData.remotekey.margin">
                      <label for="setting_detail_remotekey_margin30">{{locale.editor_setting_wide}}</label>
                    </div>
                  </div>
                </div>
                <div class="optionGroup">
                  <div class="label toCapitalize colorGrey">{{ locale.remotekey_size }}</div>
                  <div class="box">
                    <div :class="{radioItem: true, active: detailData.remotekey.size === '100'}" data-item="4">
                      <input type="radio" name="setting_detail_remotekey_size" id="setting_detail_remotekey_size100" value="100" v-model="detailData.remotekey.size">
                      <label for="setting_detail_remotekey_size100">1</label>
                    </div>
                    <div :class="{radioItem: true, active: detailData.remotekey.size === '80'}" data-item="4">
                      <input type="radio" name="setting_detail_remotekey_size" id="setting_detail_remotekey_size80" value="80" v-model="detailData.remotekey.size">
                      <label for="setting_detail_remotekey_size80">4/5</label>
                    </div>
                    <div :class="{radioItem: true, active: detailData.remotekey.size === '75'}" data-item="4">
                      <input type="radio" name="setting_detail_remotekey_size" id="setting_detail_remotekey_size75" value="75" v-model="detailData.remotekey.size">
                      <label for="setting_detail_remotekey_size75">3/4</label>
                    </div>
                    <div :class="{radioItem: true, active: detailData.remotekey.size === '50'}" data-item="4">
                      <input type="radio" name="setting_detail_remotekey_size" id="setting_detail_remotekey_size50" value="50" v-model="detailData.remotekey.size">
                      <label for="setting_detail_remotekey_size50">1/2</label>
                    </div>
                  </div>
                </div>
              </div>
              <!-- //detail:: smartkey -->
              <!-- detail:: padding -->
              <div v-if="opt.name === 'padding'">
                <div class="checkbox toCapitalize f_medium">
                  <input type="checkbox" id="check_detail_padding" v-model="detailData.padding.active">
                  <label for="check_detail_padding">{{locale.padding}}</label>
                </div>
                <div v-if="detailData.padding.active">
                  <div class="optionGroup">
                    <div class="label toCapitalize colorGrey">{{locale.editor_setting_updown}}</div>
                    <div class="box">
                      <div :class="{radioItem: true, active: detailData.padding.tb === '0'}">
                        <input type="radio" name="setting_detail_padding_tb" id="setting_detail_padding_tb0" value="0" v-model="detailData.padding.tb">
                        <label for="setting_detail_padding_tb0">{{locale.none}}</label>
                      </div>
                      <div :class="{radioItem: true, active: detailData.padding.tb === '15'}">
                        <input type="radio" name="setting_detail_padding_tb" id="setting_detail_padding_tb15" value="15" v-model="detailData.padding.tb">
                        <label for="setting_detail_padding_tb15">{{locale.default}}</label>
                      </div>
                      <div :class="{radioItem: true, active: detailData.padding.tb === '30'}">
                        <input type="radio" name="setting_detail_padding_tb" id="setting_detail_padding_tb30" value="30" v-model="detailData.padding.tb">
                        <label for="setting_detail_padding_tb30">{{locale.editor_setting_wide}}</label>
                      </div>
                    </div>
                  </div>
                  <div class="optionGroup">
                    <div class="label toCapitalize colorGrey">{{locale.editor_setting_leftright}}</div>
                    <div class="box">
                      <div :class="{radioItem: true, active: detailData.padding.lr === '0'}">
                        <input type="radio" name="setting_detail_padding_lr" id="setting_detail_padding_lr0" value="0" v-model="detailData.padding.lr">
                        <label for="setting_detail_padding_lr0">{{locale.none}}</label>
                      </div>
                      <div :class="{radioItem: true, active: detailData.padding.lr === '15'}">
                        <input type="radio" name="setting_detail_padding_lr" id="setting_detail_padding_lr15" value="15" v-model="detailData.padding.lr">
                        <label for="setting_detail_padding_lr15">{{locale.default}}</label>
                      </div>
                      <div :class="{radioItem: true, active: detailData.padding.lr === '30'}">
                        <input type="radio" name="setting_detail_padding_lr" id="setting_detail_padding_lr30" value="30" v-model="detailData.padding.lr">
                        <label for="setting_detail_padding_lr30">{{locale.editor_setting_wide}}</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- //detail:: padding -->
              <!-- detail:: clock -->
              <div v-if="opt.name === 'clock'">
                <div class="label toCapitalize f_medium">{{locale.clock}}</div>
                <!-- <div class="optionGroup">
                  <div class="label toCapitalize colorGrey">타입</div>
                  <div class="box">
                    <div>
                      <span class="checkbox radio">
                        <input type="radio" name="detail_clock_type" id="detail_clock_type_digital" value="digital" v-model="detailData.clock.type">
                        <label for="detail_clock_type_digital">10:00</label>
                      </span>
                    </div>
                    <div>
                      <span class="checkbox radio">
                        <input type="radio" name="detail_clock_type" id="detail_clock_type_analog" value="analog" v-model="detailData.clock.type">
                        <label for="detail_clock_type_analog">10:00</label>
                      </span>
                    </div>
                    <div>
                      <span class="checkbox radio">
                        <input type="radio" name="detail_clock_type" id="detail_clock_type_flip" value="flip" v-model="detailData.clock.type">
                        <label for="detail_clock_type_flip">10:00</label>
                      </span>
                    </div>
                  </div>
                </div> -->
                <div class="optionGroup">
                  <div class="checkbox toCapitalize f_medium">
                    <input type="checkbox" name="setting_clock_ampm" id="setting_clock_ampm" v-model="detailData.clock.ampm">
                    <label for="setting_clock_ampm">{{locale.display_ampm}}</label>
                  </div>
                </div>
                <div class="optionGroup">
                  <div class="checkbox toCapitalize f_medium">
                    <input type="checkbox" name="setting_clock_hour24" id="setting_clock_hour24" v-model="detailData.clock.hour24">
                    <label for="setting_clock_hour24">{{locale.display_hour24}}</label>
                  </div>
                </div>
                <div class="optionGroup">
                  <div class="label toCapitalize colorGrey">{{locale.align}}</div>
                  <div class="box setAlignItems">
                    <div :class="{radioItem: true, active: detailData.clock.align === 'left'}">
                      <input type="radio" name="setting_clock_align" id="setting_clock_align_left" value="left" v-model="detailData.clock.align">
                      <label for="setting_clock_align_left">left</label>
                    </div>
                    <div :class="{radioItem: true, active: detailData.clock.align === 'center'}">
                      <input type="radio" name="setting_clock_align" id="setting_clock_align_center" value="center" v-model="detailData.clock.align">
                      <label for="setting_clock_align_center" class="center2">center</label>
                    </div>
                    <div :class="{radioItem: true, active: detailData.clock.align === 'right'}">
                      <input type="radio" name="setting_clock_align" id="setting_clock_align_right" value="right" v-model="detailData.clock.align">
                      <label for="setting_clock_align_right">right</label>
                    </div>
                  </div>
                </div>
                <div class="optionGroup">
                  <div class="label toCapitalize colorGrey">{{locale.size}}</div>
                  <div class="box">
                    <select class="input" v-model="detailData.clock.size">
                      <option
                        v-for="size in 7"
                        :key="size"
                        :value="size">{{getClockSize(size)}}</option>
                    </select>
                  </div>
                </div>
              </div>
              <!-- //detail:: clock -->
              <!-- detail:: radius -->
              <div v-if="opt.name === 'radius'">
                <div class="checkbox toCapitalize f_medium">
                  <input type="checkbox" id="check_detail_radius" v-model="detailData.radius.active">
                  <label for="check_detail_radius">{{locale.rounding}}</label>
                </div>
                <div v-if="detailData.radius.active">
                  <div class="mt10 setRadius">
                    <div class="radiusBox">BUTTON</div>
                    <div data-radius="tl"><input type="text" class="input" v-model="detailData.radius.tl"></div>
                    <div data-radius="tr"><input type="text" class="input" v-model="detailData.radius.tr"></div>
                    <div data-radius="bl"><input type="text" class="input" v-model="detailData.radius.bl"></div>
                    <div data-radius="br"><input type="text" class="input" v-model="detailData.radius.br"></div>
                  </div>
                </div>
              </div>
              <!-- //detail:: radius -->
            </div>
          </div>
        </div>
      </div>
      <!-- //detail setting options -->
    </div>
    <div v-else class="requireMessage">{{locale.editor_select_module}}</div>
    <Plu v-if="pluData"
      :pluData="pluData"
      :locale="locale"
      :orderType="orderType"
      @apply="applyPluData"
      @close="pluData = null" />
  </div>
</template>

<script>
import settings from './ModuleSettingData'
import sketch from 'vue-color/src/components/Sketch.vue'
import UNIQUE from '@/common/unique'
import UTIL from '@/common/util'
import regExp from '@/common/regExp'
import SetLink from '@/components/Util/SetLink'
import { DateTime } from 'luxon'
import moment from 'moment/moment'
import SmartVoice from '@/components/Util/SmartVoice'
import Plu from '@/components/Util/Plu'

const SETTING_DATA = Object.values(settings)

const dayOfWeek = [
  { id: 'mon', name: '월', available: true, weekday: 2 },
  { id: 'tue', name: '화', available: true, weekday: 3 },
  { id: 'wed', name: '수', available: true, weekday: 4 },
  { id: 'thu', name: '목', available: true, weekday: 5 },
  { id: 'fri', name: '금', available: true, weekday: 6 },
  { id: 'sat', name: '토', available: true, weekday: 7 },
  { id: 'sun', name: '일', available: true, weekday: 1 }
]

export default {
  name: 'SettingModule',
  props: [
    'locale',
    'isNew',
    'mId',
    'activeLang',
    'name',
    'type',
    'settingTarget',
    'settingData',
    'columnData',
    'detailData',
    'isActive',
    'hasQuantity',
    'hasPrice',
    'resource',
    'linkedProduct',
    'itemModule',
    'subOption'
  ],
  components: {
    'sketch-picker': sketch,
    SetLink,
    SmartVoice,
    Plu
  },
  computed: {
    fontSize () {
      return this.$store.getters['citeditor/getFontSize']
    },
    orderType () {
      const submitData = this.$store.getters['page/submitData']
      return submitData && submitData.submitTo && submitData.submitTo.length ? submitData.submitTo : null
    },
    supportPlu () {
      return this.$store.getters['util/getSupportPlu']
    },
    dataVariable () {
      return this.$store.state.dataVariable
    },
    variableActive () {
      const variables = this.itemModule.filter(x => x.type === 'action' && x.setting.action && x.setting.action.dataVariable).map(x => {
        return x.setting.action.dataVariable
      }).filter(x => x.length > 0)
      // 본인인증을 통해 이름, 생년월일, 전화번호는 고정으로 처리
      const certVars = this.itemModule.find(x => x.name === 'cert') ? ['guestName', 'dateOfBirth', 'guestPhone'] : []
      const varArr = this.dataVariable.filter(x => variables.includes(x))
      return varArr.concat(certVars)
    },
    checkedCategory () {
      return this.$store.getters['category/getChecked']
    },
    getAuthInfo () {
      return this.$store.getters['authentication/getAuthInfo']
    },
    settingTab () {
      const tab = [
        { type: 'layout', label: this.locale.editor_setting_layout },
        { type: 'action', label: this.locale.editor_setting_action },
        { type: 'detail', label: this.locale.editor_setting_detail }
      ]
      return tab
    },
    selectedLang () {
      return this.$store.state.setting.lang.default
    },
    dateFormat () {
      return this.$store.getters['setting/getDateFormat']
    },
    calendarRangeStart: {
      get () {
        return moment(this.settingData.action.dateFrom || moment().toISOString()).toDate()
      },
      set (date) {
        const start = moment(date)
        const end = moment(this.settingData.action.dateTo)
        if (start.isAfter(end, 'days')) {
          this.settingData.action.dateTo = date.toISOString()
        }
        if (date !== null) {
          this.settingData.action.dateFrom = date.toISOString()
        }
      }
    },
    calendarRangeEnd: {
      get () {
        return moment(this.settingData.action.dateTo || moment().add(5, 'day').toISOString()).toDate()
      },
      set (date) {
        const start = moment(this.settingData.action.dateFrom)
        const end = moment(date)
        if (start.isAfter(end, 'days')) {
          this.settingData.action.dateFrom = date.toISOString()
        }
        if (date !== null) {
          this.settingData.action.dateTo = date.toISOString()
        }
      }
    },
    calendarRangeAttr () {
      return [
        {
          highlight: 'blue',
          dates: {
            start: this.calendarRangeEnd,
            end: this.calendarRangeStart
          }
        }
      ]
    },
    disabledDates () {
      const disabledDays = this.settingData.action.disabledDays || []
      return disabledDays.map(x => {
        return x.date
      })
    },
    disabledAttr () {
      return this.disabledDates.map(x => {
        return {
          highlight: true,
          dates: x
        }
      })
    },
    disabledDateView () {
      const dayOfWeek = this.settingData.action.dayOfWeek || [
        { id: 'mon', name: '월', available: true, weekday: 2 },
        { id: 'tue', name: '화', available: true, weekday: 3 },
        { id: 'wed', name: '수', available: true, weekday: 4 },
        { id: 'thu', name: '목', available: true, weekday: 5 },
        { id: 'fri', name: '금', available: true, weekday: 6 },
        { id: 'sat', name: '토', available: true, weekday: 7 },
        { id: 'sun', name: '일', available: true, weekday: 1 }
      ]
      const weekday = dayOfWeek.filter(x => !x.available).map(x => x.weekday)
      const hasTerm = this.settingData.action.hasTerm
      const disabledDays = this.settingData.action.disabledDays ? this.settingData.action.disabledDays.map(x => x.id) : []
      const allowedToday = this.settingData.action.allowedToday
      const rangeFrom = moment(this.settingData.action.dateFrom || moment().toISOString()).add(-1, 'days').toISOString()
      const rangeTo = moment(this.settingData.action.dateTo || moment().add(5, 'day').toISOString()).add(1, 'days').toISOString()
      let dates = [{ weekdays: weekday }]
      if (hasTerm) {
        dates.push({
          start: null,
          end: rangeFrom
        })
        dates.push({
          start: rangeTo,
          end: null
        })
      }
      if (disabledDays.length) {
        disabledDays.forEach(function (x) {
          dates.push(new Date(x))
        })
      }
      if (!allowedToday) {
        dates.push(new Date())
      }
      return dates
    },
    optionMods () {
      const name = /input|radio|checkbox|select/
      const options = this.itemModule.filter(x => x.id !== this.mId && x.type === 'action' && name.test(x.name))
      const isDisabled = (id) => this.subOption.find(x => x.child === id)
      return options.map(x => {
        return {
          ...x,
          disabled: isDisabled(x.id)
        }
      })
    },
    pIdType () {
      return this.$store.getters['admin/pIdType']
    }
  },
  watch: {
    settingTarget (target) {
      this.setData()
    },
    mId () {
      this.setData()
    },
    isActive (isActive) {
      if (isActive) {
        this.setData()
      }
    },
    detailData (detail) {
      this.setData()
    }
  },
  created () {
    this.getSettingList()
  },
  mounted() {
    this.boundCloseColorPicker = (e) => {
      const clickedInsideColorPicker =
        e.target.closest('.colorPreset') ||
        e.target.closest('.vc-sketch') ||
        e.target.closest('.btnColorPicker')

      if (!clickedInsideColorPicker) {
        this.closeColorPicker()
      }
    }
    document.addEventListener('click', this.boundCloseColorPicker)
  },

  beforeDestroy() {
    document.removeEventListener('click', this.boundCloseColorPicker)
  },
  data () {
    return {
      settingType: 'layout',
      settingList: [],
      layoutList: [],
      detailList: [],
      settingAction: {},
      currentColor: {
        target: '',
        color: ''
      },
      openedColorPicker: null,
      pickerColor: null,
      chekedPrice: false,
      isRepeat: false,
      pluData: null,
      pluTarget: null
    }
  },
  methods: {
    inputNumber (target, val) { // target: ['detailData', 'qrcode'] -> this.detailData.qrcode
      const value = parseInt(regExp.numberOnly(val))
      function setValueByTarget(obj, keys, value) {
        const lastKey = keys[keys.length - 1]
        const target = keys.slice(0, -1).reduce((acc, key) => {
          if (!acc[key]) acc[key] = {}
          return acc[key]
        }, obj)

        target[lastKey] = value
      }
      setValueByTarget(this, target, value)
      
    },
    getSettingList () {
      this.settingList = this._.cloneDeep(SETTING_DATA)
    },
    setLayoutData (options) {
      /* 사용 체크한 기본 옵션으로 layoutList 생성 */
      const layoutOptions = this.settingList.filter(x => {
        const opt = options.find(o => o === x.name)
        if (opt) {
          return x.name === opt
        }
      })
      this.layoutList = layoutOptions
    },
    setActionData (mod) {
      this.settingAction = this._.cloneDeep(SETTING_DATA.find(setting => { return setting.name === mod }))
      /**
       * calendar 모듈의 달력 설정을
       * datetime의 datepicker 설정으로 병합하며
       * 기존에 사용했던 모듈에 없던 설정값 맵핑
       * 이후 calendar 모듈은 유지만 함
       */
      if (mod === 'datetime') {
        const timeRange = function () {
          let timeRange = []
          for (let i = 0; i < 24; i++) {
            timeRange.push({
              value: ('0' + i).slice(-2),
              active: true
            })
          }
          return timeRange
        }
        this.settingData.action = {
          ...this.settingData.action,
          activeDate: this.settingData.action.activeDate !== false,
          activeTime: this.settingData.action.activeTime !== false,
          hasTerm: this.settingData.action.hasTerm || false,
          dateFrom: this.settingData.action.dateFrom || moment().toISOString(),
          dateTo: this.settingData.action.dateTo || moment().add(5, 'day').toISOString(),
          hasRangeDay: this.settingData.action.hasRangeDay || false,
          rangeDayNumber: this.settingData.action.rangeDayNumber || '3',
          dayOfWeek: this.settingData.action.dayOfWeek || dayOfWeek,
          disabledDays: this.settingData.action.disabledDays || [],
          allowedToday: this.settingData.action.allowedToday !== false,
          allowedPast: this.settingData.action.allowedPast !== false,
          hasRangeTime: this.settingData.action.hasRangeTime || false,
          rangeTimeNumber: this.settingData.action.rangeTimeNumber || timeRange()
        }
      } else if (mod === 'calendar') {
        this.settingData.action = {
          ...this.settingData.action,
          hasRangeDay: this.settingData.action.hasRangeDay || false,
          rangeDayNumber: this.settingData.action.rangeDayNumber || '3'
        }
      }
    },
    setDetailData (column) {
      const detailOptions = this.settingList.filter(x => {
        const opt = column.options.find(o => o === x.name)
        return x.name === opt
      })
      this.detailList = detailOptions
    },
    setData () {
      if (this.settingTarget === 'column') {
        if (this.detailData) {
          this.setDetailData(this.detailData)
          this.settingType = 'detail'
        }
      } else if (this.settingTarget === 'mods') {
        this.setLayoutData(this.settingData.layout.options)
        this.settingType = this.type === 'standard' || this.settingData.action === null ? 'layout' : 'action'
        if (this.settingData.action !== null) {
          this.setActionData(this.settingData.action.name)
        }
      }
    },
    onTabClick: function (e) {
      let type = e.target.dataset.setting_type
      this.settingType = type
      if (typeof (this.settingData) !== 'undefined') {
        if (type === 'layout') {
          this.setLayoutData(this.settingData.layout.options)
        } else if (type === 'action' && this.settingData.action !== null) {
          this.setActionData(this.settingData.action.name)
        } else if (type === 'detail' && !this._.isEmpty(this.detailData)) {
          this.setDetailData(this.detailData)
        }
      }
    },

    onChangeColor (color) {
      const value = this.toRgbaString(color)
      this.currentColor.color = value
      const key = this.currentColor.target
      if (key === 'action') {
        this.settingData.action.color = value
        return
      }
      if (this.settingType === 'detail') {
        this.detailData[key].color = value
        return
      }
      this.settingData.layout[key].color = value
    },
    toRgbaString (color) {
      const { r, g, b, a } = color.rgba
      return `rgba(${r}, ${g}, ${b}, ${a})`
    },
    toggleColorPicker (key, color) {
      this.currentColor.target = key
      this.currentColor.color = color
      this.openedColorPicker = this.openedColorPicker === key ? null : key
    },
    closeColorPicker () {
      this.openedColorPicker = null
    },
    uploadImage (item, e) {
      const data = {
        id: UNIQUE.mid(),
        file: e.target.files[0]
      }
      const isImage = regExp.image.test(data.file.name.slice(data.file.name.lastIndexOf('.') + 1).toLowerCase())
      if (isImage) {
        this.$store.dispatch('util/uploadFile', data).then((res) => {
          item.value = res.source
          e.target.value = ''
        })
      } else {
        alert(this.locale.validate_upload_image)
      }
    },
    deleteImage (item) {
      if (window.confirm(this.locale.confirm_delete_image)) {
        item.value = ''
      }
    },
    actionColor (c) {
      const rgba = `rgba(${c.rgba.r}, ${c.rgba.g}, ${c.rgba.b}, ${c.rgba.a})`
      // const target = this.currentColor.target
      this.currentColor.color = rgba
      this.settingData.action.color = rgba
    },
    settingColor (c) {
      const rgba = `rgba(${c.rgba.r}, ${c.rgba.g}, ${c.rgba.b}, ${c.rgba.a})`
      const target = this.currentColor.target
      this.currentColor.color = rgba
      this.settingData.layout[target].color = rgba
    },
    settingDetailColor (c) {
      const rgba = `rgba(${c.rgba.r}, ${c.rgba.g}, ${c.rgba.b}, ${c.rgba.a})`
      const target = this.currentColor.target
      this.currentColor.color = rgba
      this.detailData[target].color = rgba
    },
    settingDetailColorHex (c) {
      const hex = c.hex
      const target = this.currentColor.target
      this.currentColor.color = hex
      this.detailData[target].color = hex
    },
    addOption (data) {
      if (data.optionQuantity) {
        data.itemDefault.quantity = data.min
      }
      this.$emit('addOption', data)
    },
    removeOption (option, index, action) {
      const data = {
        option: option,
        index: index,
        action: action
      }
      this.$emit('removeOption', data)
    },
    itemPrice (item) {
      item.price = Number(item.price)
    },
    pagePrice (page) {
      page.price.value = Number(page.price.value)
    },
    settimeDay (e) {
      const val = e.target.value
      const setDateTo = moment().add(val, 'days').toISOString()
      this.settingData.action.settime.dateTo = setDateTo
    },
    checkedPrice (isChecked) {
      this.$emit('checkedPrice', isChecked)
    },
    setHasDefault (hasDefault) {
      switch (this.name) {
        case 'checkbox':
          this.settingData.action.defaultValue = []
          break
        case 'option':
          this.settingData.action.defaultValue = []
          break
        case 'radio':
          this.settingData.action.defaultValue = ''
          break
      }
    },
    setOptionQuantity () {
      const min = this.settingData.action.min || 1
      const max = this.settingData.action.max || 3
      this.settingData.action.min = min
      this.settingData.action.max = min > max ? min : max
      this.settingData.action.item = this.settingData.action.item.map(x => {
        return {
          ...x,
          quantity: min
        }
      })
    },
    setOptionCondition () {
      const defaultCondition = {
        gt: {
          checked: false,
          value: 1
        },
        lt: {
          checked: false,
          value: this.settingData.action.item.length
        },
        specific: {
          checked: false,
          value: 1
        }
      }
      this.settingData.action.condition = this.settingData.action.condition || defaultCondition
    },
    setNumber: function (data, value) {
      data[value] = Number(regExp.numberOnly(data[value]))
    },
    setRate: function (data) {
      let value = Number(regExp.numberOnly(data.max))
      this.validateRate(value)
      if (data.max !== '') {
        if (value > 10) {
          value = 10
        } else if (value < 3) {
          value = 3
        }
        data.max = value
        data.rateValue = value - 1
      }
    },
    validateRate (max) {
      const message = Number(max) === 0 ? this.locale.validate_rate_set : ''
      return message
    },
    checkOptionCondition (condition, event) {
      const isChecked = event.target.value
      const hasGt = this.settingData.action.conditionGt
      const hasLt = this.settingData.action.conditionLt
      const hasSpecific = this.settingData.action.conditionSpecific
      if (isChecked) {
        if (condition === 'gt' && hasSpecific) {
          // '최소 조건을 설정하면 지정 조건이 해제됩니다.'
          if (window.confirm(this.locale.confirm_product_set_gt)) {
            this.settingData.action.conditionSpecific = false
          } else {
            this.settingData.action.conditionGt = false
            event.preventDefault()
          }
        }
        if (condition === 'lt' && hasSpecific) {
          // '최대 조건을 설정하면 지정 조건이 해제됩니다.'
          if (window.confirm(this.locale.confirm_product_set_lt)) {
            this.settingData.action.conditionSpecific = false
          } else {
            this.settingData.action.conditionLt = false
            event.preventDefault()
          }
        }
        if (condition === 'specific' && (hasGt || hasLt)) {
          // '지정 조건을 설정하면 최소, 최대 조건이 해제됩니다.'
          if (window.confirm(this.locale.confirm_product_set_specific)) {
            this.settingData.action.conditionGt = false
            this.settingData.action.conditionLt = false
          } else {
            this.settingData.action.conditionSpecific = false
            event.preventDefault()
          }
        }
      }
    },
    getClockSize (size) {
      size = String(size)
      switch (size) {
        case '1':
          return '14px'
        case '2':
          return '16px'
        case '3':
          return '24px'
        case '4':
          return 'default'
        case '5':
          return '40px'
        case '6':
          return '52px'
        case '7':
          return '68px'
      }
    },
    getConditionKey (key) {
      switch (key) {
        case 'gt':
          return 'conditionGtVal'
        case 'lt':
          return 'conditionLtVal'
        case 'specific':
          return 'conditionSpecificVal'
      }
    },
    optionConditionVal (key, event) {
      const value = Number(regExp.numberOnly(event.target.value))
      this.settingData.action[this.getConditionKey(key)] = value
      return value
    },
    validateOptionCondition (key, isChecked) {
      const value = this.settingData.action[this.getConditionKey(key)]
      const max = this.settingData.action.item.length
      const hasGt = this.settingData.action.conditionGt
      const hasLt = this.settingData.action.conditionLt
      const gtVal = this.settingData.action.conditionGtVal
      const ltVal = this.settingData.action.conditionLtVal
      let message = ''
      if (isChecked) {
        if (key === 'gt') {
          if (value < 1) {
            message = this.locale.validate_option_condition_gt1
          } else if (value > max) {
            message = this.locale.validate_option_condition_length
          } else if (hasLt && value > ltVal) {
            message = this.locale.validate_option_condition_ltmax
            this.settingData.action.conditionLtVal = value
          }
        } else if (key === 'lt') {
          if (value < 1) {
            message = this.locale.validate_option_condition_gt1
          } else if (value > max) {
            message = this.locale.validate_option_condition_length
          } else if (hasGt && value < gtVal) {
            message = this.locale.validate_option_condition_gtmin
          }
        } else if (key === 'specific') {
          if (value < 1) {
            message = this.locale.validate_option_condition_gt1
          } else if (value > max) {
            message = this.locale.validate_option_condition_length
          }
        }
      }
      return message
    },
    setQuantity: function (data, key) {
      const value = Number(regExp.numberOnly(data[key]))
      data[key] = value
      if (key === 'min') {
        data.value = value
        data.item = data.item.map(x => {
          return {
            ...x,
            quantity: data.min
          }
        })
      }
      return value
    },
    validateQuantity (data) {
      const min = Number(data.min)
      const max = Number(data.max)
      const isPass = min <= max
      const message = !isPass ? this.locale.validate_quantity_minmax : ''
      if (!isPass) {
        data.max = min
      }
      return message
    },
    setLabelFontSize (e) {
      const size = e.target.value
      this.settingData.action.labelFontSize = size
      // console.log(size)
      // console.log(this.settingData.action.labelFontSize)
    },
    updateLabel (target, e) {
      const value = e.target.value
      if (this.isNew) {
        Object.keys(target.label).forEach(function (lang) {
          target.label[lang] = value
        })
      }
      const fillValue = UTIL.fillLangs(target.label, target.label[this.activeLang])
      target.label = fillValue
    },
    updateDetailLabel (target, e) {
      const value = e.target.value
      if (this.isNew) {
        Object.keys(target.label).forEach(function (lang) {
          target.label[lang] = value
        })
      }
      const fillValue = UTIL.fillLangs(target.label, target.label[this.activeLang])
      target.label = fillValue
    },
    updateSubmits () {
      const isSubmit = this.detailData.button.type === 'submit'
      this.$store.dispatch('page/updateSubmits', isSubmit)
    },
    onDisabledDayClick (day) {
      const idx = this.settingData.action.disabledDays.findIndex(d => d.id === day.id)
      if (idx >= 0) {
        this.settingData.action.disabledDays.splice(idx, 1)
      } else {
        this.settingData.action.disabledDays.push({
          id: day.id,
          date: day.date,
          iso: day.date.toISOString()
        })
      }
    },
    toFormat (date) {
      const iso = typeof (date) === 'string' ? date : date.toISOString()
      return DateTime.fromISO(iso).toFormat(this.dateFormat)
    },
    setPidType (item) {
      const id = item.pIdTypeId
      item.pIdType = this._.cloneDeep(this.pIdType.find(x => x.id === id))
    },
    activeLink () {
      const hasUpload = this.detailData.upload
      const isActive = this.detailData.link.active
      if (isActive && hasUpload) {
        alert(this.locale.alert_upload_disabled)
        this.detailData.upload.active = false
      }
    },
    setPlu (item, index) {
      this.pluData = item
      this.pluTarget = index
    },
    applyPluData (data) {
      const index = this.pluTarget
      this.settingData.action.item = this.settingData.action.item.map((x, i) => {
        return i === index ? data : x
      })
      this.pluData = null
      this.pluTarget = null
    }
  }
}
</script>
